webpackJsonp([49],Array(45).concat([
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns__);



function exactDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';
	var splitBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'T';

	if (date) {
		var dateSplit = date.split(splitBy);
		var dateComplete = dateSplit[0].split('-');
		var year = dateComplete[0];
		var month = dateComplete[1] - 1;
		var day = dateComplete[2];
		var newDate = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["format"])(new Date(year, month, day), formatter);
		return newDate;
	}
	return null;
}

function formatDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';

	var newDate = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["format"])(new Date(date), formatter);
	return newDate;
}

function allTrue() {
	for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		args[_key] = arguments[_key];
	}

	return args.every(function (a) {
		return a;
	});
}

function roundToDecimal(num) {
	var decimal = 2;
	return Math.round(num * Math.pow(10, decimal)) / Math.pow(10, decimal);
}

function generateBlob(data) {
	var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'application/pdf';

	return new Blob([data], { type: contentType });
}

function getLocalData(key) {
	return JSON.parse(localStorage.getItem("quipu" + '::' + key));
}

function getLocalStorage() {
	return JSON.parse(localStorage.getItem('' + "quipu"));
}

function getLocalToken() {
	return localStorage.getItem("quipu" + '::token');
}

function removeLocalData(key) {
	return localStorage.removeItem("quipu" + '::' + key);
}

function setLocalData(key, data) {
	return localStorage.setItem("quipu" + '::' + key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
}

function showDownloadDialog(blob, name) {
	var currentDate = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["format"])(new Date(), 'YYYY-MM-DD');
	var link = document.createElement('a');
	link.download = name + '_' + currentDate;
	link.href = window.URL.createObjectURL(blob);
	link.click();
}

/* eslint-disable */
function debounce(func) {
	var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 800;
	var immediate = arguments[2];

	var timeout;
	return function () {
		var context = this,
		    args = arguments;
		var later = function later() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var methods = {
	allTrue: allTrue,
	debounce: debounce,
	exactDate: exactDate,
	formatDate: formatDate,
	generateBlob: generateBlob,
	getLocalData: getLocalData,
	getLocalStorage: getLocalStorage,
	getLocalToken: getLocalToken,
	removeLocalData: removeLocalData,
	setLocalData: setLocalData,
	showDownloadDialog: showDownloadDialog,
	roundToDecimal: roundToDecimal
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */,
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18e6e768_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__ = __webpack_require__(637);
function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18e6e768"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18e6e768_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//



function snackbar() {
	return this.$store.getters.snackbar;
}

function created() {
	var adminUser = JSON.parse(localStorage.getItem("quipu" + '::adminUser'));
	if (!this.userName && adminUser) {
		this.setUser(adminUser);
	}
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	created: created,
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		snackbar: snackbar
	}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['userName'])),
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['setUser']))
});

/***/ }),
/* 136 */,
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_user_userModule__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_routing_routeModule__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_subsidiary_subsidiaryModule__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_costCenter_costCenterModule__ = __webpack_require__(606);











__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
	modules: {
		costCenter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_9__modules_costCenter_costCenterModule__["a" /* default */]),
		route: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_7__modules_routing_routeModule__["a" /* default */]),
		subsidiary: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_8__modules_subsidiary_subsidiaryModule__["a" /* default */]),
		user: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_6__modules_user_userModule__["a" /* default */])
	},
	state: {
		appConfig: {
			isLoading: false,
			snackbar: {
				text: '',
				isVisible: false,
				color: 'primary'
			}
		}
	},
	actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
	getters: __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* default */],
	mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action__ = __webpack_require__(632);





var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this = this;

		var appCode, uri, params, headers, _ref2, actions, actionHelp;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						appCode = 'quipu-admin';
						uri = this.resourceUri;
						params = {
							languages: 'es'
						};
						headers = {
							Accept: 'application/vnd.apiacl.v2+json'
						};
						_context.prev = 4;
						_context.next = 7;
						return this.$httpAcl.get('sidebar/' + appCode + '/resource/' + uri, { params: params, headers: headers });

					case 7:
						_ref2 = _context.sent;
						actions = _ref2.data;
						actionHelp = {
							id: actions.length + 1,
							code: 'HELP',
							icon: 'help',
							name: 'Necesitas Ayuda?'
						};

						this.actions = actions.data.map(function (actionSingle) {
							var newAction = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, actionSingle);
							var index = _this.valueDisabled.findIndex(function (val) {
								return val.code === actionSingle.code;
							});
							newAction.name = actionSingle.languages;
							newAction.disabled = index > -1 && _this.valueDisabled[index].disabled;
							return newAction;
						});
						this.actions.push(actionHelp);
						_context.next = 17;
						break;

					case 14:
						_context.prev = 14;
						_context.t0 = _context['catch'](4);

						this.showGenericError();

					case 17:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[4, 14]]);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function created() {
	this.loadData();
}

function actionDisabled(values) {
	this.actions = this.actions.reduce(function (accum, act) {
		var newAction = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, act);
		var index = values.findIndex(function (v) {
			return v.code === act.code;
		});
		newAction.disabled = index > -1 && values[index].disabled;
		accum.push(newAction);
		return accum;
	}, []);
}

function openAction(item) {
	if (item.code === 'HELP') {
		var helpIndex = this.actions.findIndex(function (act) {
			return act.code === item.code;
		});
		var newActions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.actions);
		newActions.splice(helpIndex, 1);
		var model = {
			code: item.code,
			actions: newActions
		};
		this.$emit('open-help', model);
	} else {
		this.$emit('run-action', item);
	}
}

function data() {
	return {
		actions: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'action-bar',
	components: {
		action: __WEBPACK_IMPORTED_MODULE_4__action__["a" /* default */]
	},
	created: created,
	data: data,
	methods: {
		loadData: loadData,
		openAction: openAction
	},
	props: {
		resourceUri: {
			required: true,
			type: String
		},
		valueDisabled: {
			default: function _default() {
				return [];
			},
			type: Array
		}
	},
	watch: {
		valueDisabled: {
			deep: true,
			handler: actionDisabled
		}
	}
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function hasHotKeys() {
	return this.hotKeys && this.hotKeys.length > 0;
}

function openAction() {
	this.$emit('open-action');
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'action',
	computed: {
		hasHotKeys: hasHotKeys
	},
	inheritAttrs: false,
	methods: {
		openAction: openAction
	},
	props: {
		action: {
			required: true,
			type: Object
		},
		hotKeys: {
			default: function _default() {
				return [];
			},
			type: Array
		}
	}
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function clickIcon($e) {
	this.$emit('click-icon', $e);
}

function isListAll() {
	return this.icon === 'list_all' ? 'height:24px;width:24px' : '';
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-tooltip-button',
	computed: {
		isListAll: isListAll
	},
	props: {
		color: {
			type: String,
			default: 'green'
		},
		icon: String,
		img: String,
		size: Number,
		text: {
			type: String,
			required: true
		},
		width: {
			default: 20,
			type: Number
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		clickIcon: clickIcon
	}
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function closeDrawer() {
	this.$emit('close-modal', false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'action-sidebar',
	methods: {
		closeDrawer: closeDrawer
	},
	model: {
		prop: 'value',
		event: 'close-modal'
	},
	props: {
		title: {
			type: String,
			required: true
		},
		value: {
			type: Boolean,
			required: true
		},
		width: {
			type: Number,
			default: 600
		},
		codeAction: {
			type: String,
			required: false
		},
		imgSrc: {
			type: String
		},
		headerColor: {
			type: String,
			default: 'white'
		},
		isLoading: {
			default: false,
			type: Boolean
		}
	}
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function blurAction(val) {
	this.$emit('blur', val);
}

function sendValue(val) {
	this.$emit('input', val);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'base-input',
	inheritAttrs: false,
	methods: {
		blurAction: blurAction,
		sendValue: sendValue
	},
	props: {
		height: {
			default: 30,
			type: Number
		},
		isLoading: {
			type: Boolean,
			default: false
		},
		value: null
	}
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

function style() {
	return 'width: ' + this.width + 'px; height: ' + this.height + 'px';
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-button',
	inheritAttrs: false,
	computed: {
		style: style
	},
	props: {
		text: {
			type: String,
			default: 'Aceptar'
		},
		isLoading: {
			type: Boolean,
			default: false
		},
		blue: {
			type: Boolean,
			default: false
		},
		red: {
			type: Boolean,
			default: false
		},
		green: {
			type: Boolean,
			default: false
		},
		gray: {
			type: Boolean,
			default: false
		},
		width: {
			type: [Number, String]
		},
		height: {
			type: [Number, String],
			default: '35'
		}
	}
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_action_bar_action_bar__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_helper__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(20);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var LOCAL_SEARCH_EVENT = 'on-local-search';
var SEARCH_EVENT = 'on-search-event';

function open() {
	this.show = !this.show;
}

function searchRows($event) {
	var keyCode = $event.keyCode;
	if (keyCode === 27) {
		this.search = '';
	}
	if (this.localSearch) {
		var dataToLocalSearch = this.search.toLowerCase();
		__WEBPACK_IMPORTED_MODULE_4__shared_helper__["a" /* default */].setLocalData(this.$attrs.name + '::search', dataToLocalSearch);
		this.$emit(LOCAL_SEARCH_EVENT, dataToLocalSearch);
	} else {
		__WEBPACK_IMPORTED_MODULE_4__shared_helper__["a" /* default */].setLocalData(this.$attrs.name + '::search', this.search);
		this.$emit(SEARCH_EVENT, this.search);
	}
}

function mounted() {
	this.setWitdh();
	window.addEventListener('resize', this.setWitdh);
}

function columnsToExport() {
	var columnsSelected = this.columns.filter(function (column) {
		return column.visible && !column.flagVisible;
	});
	var newColumns = columnsSelected.map(function (col) {
		var newCol = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, col);
		delete newCol.id;
		delete newCol.visible;
		delete newCol.checked;
		return newCol;
	});
	return newColumns;
}

function dataToExport() {
	var tableDataToExport = [];
	var columnsSelected = this.columns.filter(function (column) {
		return column.visible && !column.flagVisible;
	});
	var columnsValues = columnsSelected.map(function (colVal) {
		var newColVal = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, colVal);
		return newColVal.value;
	});
	if (this.rows.length > 0) {
		tableDataToExport = this.rows.map(function (dataExport) {
			var newData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, dataExport);
			var keysData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dataExport);
			keysData.forEach(function (keyData) {
				if (columnsValues.every(function (keyCol) {
					return keyCol !== keyData;
				})) {
					delete newData[keyData];
				}
			});
			return newData;
		});
	}
	return tableDataToExport;
}

function downloadDispatch() {
	this.$emit('download-dispatch');
}

function downloadDocument() {
	this.exportTable(this.columnsToExport, this.dataToExport, this.name);
}

function print() {
	window.print();
}

function openAction(item) {
	this.$emit('run-action', item);
}

function setWitdh() {
	this.width = window.innerWidth;
}

function titleBreadCrumb(bc) {
	return bc.title || bc.meta.title;
}

function data() {
	return {
		search: '',
		show: false,
		width: 0
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'header-page',
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('route', ['getBreadCrumbs']), {
		columnsToExport: columnsToExport,
		dataToExport: dataToExport
	}),
	components: {
		actionBar: __WEBPACK_IMPORTED_MODULE_3__components_shared_action_bar_action_bar__["a" /* default */]
	},
	data: data,
	methods: {
		open: open,
		downloadDispatch: downloadDispatch,
		downloadDocument: downloadDocument,
		print: print,
		openAction: openAction,
		searchRows: searchRows,
		setWitdh: setWitdh,
		titleBreadCrumb: titleBreadCrumb
	},
	mounted: mounted,
	props: {
		columns: {
			type: Array
		},
		exportToPdf: {
			default: false,
			type: Boolean
		},
		name: {
			type: String
		},
		rows: {
			type: Array
		},
		showClean: {
			default: true,
			type: Boolean
		},
		showExcel: {
			default: true,
			type: Boolean
		},
		title: {
			type: String,
			required: true
		},
		toShow: {
			default: false,
			type: Boolean
		},
		quotation: {
			default: false,
			type: Boolean
		},
		sale: {
			default: false,
			type: Boolean
		},
		actions: {
			default: false,
			type: Boolean
		},
		searchHeader: {
			default: false,
			type: Boolean
		},
		valueDisabled: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		buttonDelete: {
			default: false,
			type: Boolean
		},
		buttonFilter: {
			default: false,
			type: Boolean
		},
		buttonClose: {
			default: false,
			type: Boolean
		},
		codeJournal: {
			type: String
		},
		dateJournal: {
			type: String
		},
		detailJournalOpen: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'general-filter'
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_app_tooltip_button__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table_column_item__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_helper__ = __webpack_require__(45);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var ADD_REQUEST_EVENT = 'on-add-event';
var LOCAL_SEARCH_EVENT = 'on-local-search';
var SEARCH_EVENT = 'on-search-event';
var ON_DRAG_EVENT = 'on-drag-event';
var ON_DRAG_ENTER = 'on-drag-enter';
var ON_DRAG_LEAVE = 'on-drag-leave';
var ON_DROP_EVENT = 'on-drop-event';
var ON_PAGE_EVENT = 'on-page';
var ROW_IS_SELECTED = 'row-is-selected';
var ROW_ON_CLICK = 'row-on-click';
var SELECTED_ALL_EVENT = 'on-selected-all';
var TABLE_OPTION_EVENT = 'table-option-event';
var TABLE_CLEAR_FILTER = 'clear-filter';

var components = {
	TableColumnItem: __WEBPACK_IMPORTED_MODULE_2__table_column_item__["a" /* default */],
	appTooltipButton: __WEBPACK_IMPORTED_MODULE_1__components_shared_app_tooltip_button__["a" /* default */]
};

function addOption() {
	this.$emit(ADD_REQUEST_EVENT);
}

function addAIconAction() {
	this.$emit('add-icon');
}

function pagination(pageNumber, totalRecords) {
	var current = pageNumber;
	var last = totalRecords;
	var delta = 2;
	var left = current - delta;
	var right = current + delta + 1;
	var range = [];
	var rangeWithDots = [];
	var l = null;

	for (var i = 1; i <= last; i += 1) {
		/* eslint-disable no-mixed-operators */
		if (i === 1 || i === last || i >= left && i < right) {
			range.push(i);
		}
	}

	/* eslint-disable no-restricted-syntax */
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(range), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _i = _step.value;

			if (l) {
				if (_i - l === 2) {
					rangeWithDots.push(l + 1);
				} else if (_i - l !== 1) {
					rangeWithDots.push('...');
				}
			}
			rangeWithDots.push(_i);
			l = _i;
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return rangeWithDots;
}

function data() {
	return {
		direction: 'right',
		search: '',
		showMenu: false
	};
}

function mounted() {
	window.addEventListener('resize', this.optionsDirection);
	this.optionsDirection();
	var columnsInLocalStorage = __WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].getLocalData(this.$attrs.name + '::columns');
	if (columnsInLocalStorage) {
		this.columns.forEach(function (col) {
			var newCol = col;
			var colToChange = columnsInLocalStorage.find(function (c) {
				return c.id === newCol.id;
			});
			if (colToChange) {
				newCol.visible = colToChange.visible;
				newCol.checked = colToChange.checked;
			}
		});
	}
	if (this.localStorage) {
		var searchFromLocalStorage = __WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].getLocalData(this.$attrs.name + '::search');
		if (searchFromLocalStorage) {
			this.search = searchFromLocalStorage;
			this.$emit(SEARCH_EVENT, searchFromLocalStorage);
		}
	}
}

function toggleColumns() {
	var _this = this;

	this.selectedColumns = this.columns.filter(function (c) {
		return !c.checked;
	});
	this.columns.forEach(function (col) {
		var newCol = col;
		var colToChange = _this.selectedColumns.find(function (c) {
			return c.id === newCol.id;
		});
		newCol.visible = typeof colToChange === 'undefined';
	});
	__WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].setLocalData(this.$attrs.name + '::columns', this.selectedColumns);
	this.showMenu = false;
}

function selectedAll(_ref) {
	var target = _ref.target;

	this.$emit(SELECTED_ALL_EVENT, target.checked);
}

function rowIsSelected(row) {
	if (this.selectable) {
		this.$set(row, 'isSelected', !row.isSelected);
		this.$emit(ROW_IS_SELECTED, row);
	} else {
		this.$emit(ROW_ON_CLICK, row);
	}
}

function searchRows($event) {
	var keyCode = $event.keyCode;
	if (keyCode === 27) {
		this.search = '';
	}
	if (this.localSearch) {
		var dataToLocalSearch = this.search.toLowerCase();
		__WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].setLocalData(this.$attrs.name + '::search', dataToLocalSearch);
		this.$emit(LOCAL_SEARCH_EVENT, dataToLocalSearch);
	} else {
		__WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].setLocalData(this.$attrs.name + '::search', this.search);
		this.$emit(SEARCH_EVENT, this.search);
	}
}

function onDragEnter(row) {
	this.$emit(ON_DRAG_ENTER, row);
}

function onDragLeave(row) {
	this.$emit(ON_DRAG_LEAVE, row);
}

function onDrop(row) {
	this.$emit(ON_DROP_EVENT, row);
}

function onDrag(row) {
	this.$emit(ON_DRAG_EVENT, row);
}

function changePage(page) {
	if (page !== '...') {
		if (page !== this.currentPage) {
			this.$emit(ON_PAGE_EVENT, page);
		}
	}
}

function cleanSearch(val) {
	if (val) {
		this.search = '';
	}
}

function selectPage(page) {
	var newPage = page > this.lastPage ? this.lastPage : page;
	newPage = newPage <= 0 ? 1 : newPage;
	changePage.call(this, Number(newPage));
}

function selectLastPage() {
	changePage.call(this, this.lastPage);
}

function tableOption() {
	var action = {
		active: true,
		code: 'filter-by',
		color: '#fafafa',
		imgSrc: '/static/img/actions-list/cancel.svg',
		open: true,
		title: 'FILTRAR POR',
		width: 229
	};
	this.$emit(TABLE_OPTION_EVENT, action);
}

function createAction() {
	this.$emit('create-action');
}

function openDeleteSeat() {
	var action = {
		active: true,
		code: 'delete-seat',
		color: '#fafafa',
		imgSrc: 'https://japi-static.s3.amazonaws.com/japi-sales-error/behind.png',
		open: true,
		title: 'Eliminar Asiento',
		width: 300
	};
	this.$emit('delete-seat', action);
}

function optionsDirection() {
	if (window.innerWidth < 768) {
		this.direction = 'center';
	} else {
		this.direction = 'right';
	}
}

function totalVisibleColumns() {
	return this.columns.filter(function (c) {
		return c.visible;
	}).length + 1;
}

function pages() {
	return pagination(this.currentPage, this.lastPage);
}

function tableClearFilter() {
	this.$emit(TABLE_CLEAR_FILTER);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-table',
	components: components,
	computed: {
		pages: pages,
		totalVisibleColumns: totalVisibleColumns
	},
	data: data,
	methods: {
		addOption: addOption,
		addAIconAction: addAIconAction,
		createAction: createAction,
		openDeleteSeat: openDeleteSeat,
		onDrag: onDrag,
		onDragEnter: onDragEnter,
		onDragLeave: onDragLeave,
		onDrop: onDrop,
		optionsDirection: optionsDirection,
		rowIsSelected: rowIsSelected,
		searchRows: searchRows,
		selectedAll: selectedAll,
		selectPage: selectPage,
		selectLastPage: selectLastPage,
		tableOption: tableOption,
		toggleColumns: toggleColumns,
		tableClearFilter: tableClearFilter
	},
	mounted: mounted,
	props: {
		addButton: {
			default: false,
			type: Boolean
		},
		captionQuantity: {
			default: true,
			type: Boolean
		},
		itemsQuantity: [Number, String],
		title: [Number, String],
		itemsTotalQuantity: [Number, String],
		checkAll: {
			type: Boolean,
			default: false
		},
		columns: {
			type: Array,
			required: true
		},
		action: {
			default: false,
			type: Boolean
		},
		flagTitle: {
			default: false,
			type: Boolean
		},
		currentPage: {
			type: Number,
			default: 1
		},
		dispatchDetail: {
			default: false,
			type: Boolean
		},
		filterColumns: {
			default: true,
			type: Boolean
		},
		hideSelectableOnMovil: {
			default: false,
			type: Boolean
		},
		includeFilter: {
			type: Boolean,
			default: false
		},
		inputSearch: {
			default: true,
			type: Boolean
		},
		localSearch: {
			type: Boolean,
			default: false
		},
		localStorage: {
			type: Boolean,
			default: false
		},
		rows: {
			type: Array,
			required: true
		},
		selectable: {
			type: Boolean,
			default: false
		},
		lastPage: {
			type: Number,
			default: 0
		},
		keyValue: {
			type: String,
			default: 'id'
		},
		mainList: {
			type: Boolean,
			default: true
		},
		cleanSearch: {
			default: false,
			type: Boolean
		},
		detailSeat: {
			default: false,
			type: Boolean
		},
		deleteSeat: {
			default: false,
			type: Boolean
		},
		editCont: {
			default: false,
			type: Boolean
		},
		showNewSeat: {
			default: false,
			type: Boolean
		},
		showDetailSeat: {
			default: false,
			type: Boolean
		},
		nameTooltip: {
			type: String,
			default: ''
		},
		addIcon: {
			type: Boolean,
			default: false
		},
		tooltipDelete: {
			type: String,
			default: ''
		},
		clearFilter: {
			default: false,
			type: Boolean
		},
		showAccounting: {
			type: Boolean,
			default: false
		},
		showTableAccounting: {
			type: Boolean,
			default: false
		},
		rowsDetails: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		showRecord: {
			type: Boolean,
			default: false
		},
		disabledEditAccou: {
			type: Boolean,
			default: true
		},
		createdAdd: {
			type: Boolean,
			default: true
		},
		numberSeats: {
			type: Number,
			default: 0
		},
		tFoot: {
			type: Boolean,
			default: true
		},
		showExcel: {
			type: Boolean,
			default: false
		},
		height: {
			type: Number,
			default: 18
		},
		downButton: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		cleanSearch: cleanSearch
	}
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var SORTABLE_COLUMN_EVENT = 'on-column-sortable';

function data() {
	return {
		showInput: false
	};
}

function onColumnSortable(column) {
	this.$emit(SORTABLE_COLUMN_EVENT, column);
}

function toggleInput(column) {
	var _this = this;

	this.$set(column, 'showInput', !column.showInput);
	if (column.showInput) {
		this.$nextTick(function () {
			var columnInput = _this.$refs['colheader' + column.id];
			if (columnInput) {
				columnInput.focus();
			}
		});
	}
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'table-column-item',
	data: data,
	props: {
		column: {
			type: Object,
			required: true
		},
		onCloumnSortable: {
			type: Function
		}
	},
	methods: {
		onColumnSortable: onColumnSortable,
		toggleInput: toggleInput
	}
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'layout-login'
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_action_sidebar__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_app_header__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_app_sidebar__ = __webpack_require__(707);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function closeNotificationsModal() {
	this.action.active = false;
	this.action.open = false;
}

function getRoutes(routes) {
	this.routes = routes;
}

function notifications() {
	var allNotifications = [];
	if (this.productsNotifications.length > 0) {
		this.productsNotifications.forEach(function (productNot) {
			allNotifications.push(productNot);
		});
	}
	if (this.salesNotifications.length > 0) {
		this.salesNotifications.forEach(function (saleNot) {
			allNotifications.push(saleNot);
		});
	}
	return allNotifications;
}

function openNotificationsModal() {
	this.action.active = true;
	this.action.open = true;
}

function quantityNotifications() {
	return 0;
}

function toggleSidebar() {
	this.isVisible = !this.isVisible;
}

function routeHandler(to, from) {
	var fromRoute = {
		name: from.name,
		params: from.params,
		query: from.query,
		meta: from.meta
	};
	var toRoute = {
		name: to.name,
		params: to.params,
		query: to.query,
		meta: to.meta
	};
	var onlyRoute = toRoute.name === 'company-new' && fromRoute.name !== 'companies';
	this.$setBreadCrumbs({ fromRoute: fromRoute, toRoute: toRoute, onlyRoute: onlyRoute });
}

function openSiderbar() {
	this.mini = !this.mini;
}

function showIndeterminate() {
	return this.$store.getters.indeterminate;
}

function clickListItem() {
	if (this.$route.name === 'journal') {
		this.mini = true;
	} else {
		this.mini = false;
	}
}

function data() {
	return {
		action: {
			active: false,
			code: 'NOT',
			open: false,
			title: 'Notificaciones',
			width: 468
		},
		isVisible: true,
		loading: false,
		routes: [],
		mini: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'layout-admin',
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_2__components_shared_action_sidebar__["a" /* default */],
		appHeader: __WEBPACK_IMPORTED_MODULE_3__components_shared_app_header__["a" /* default */],
		appSidebar: __WEBPACK_IMPORTED_MODULE_4__components_shared_app_sidebar__["a" /* default */]
	},
	computed: {
		showIndeterminate: showIndeterminate,
		notifications: notifications,
		quantityNotifications: quantityNotifications
	},
	data: data,
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('route', {
		$setBreadCrumbs: 'SET_BREAD_CRUMBS'
	}), {
		closeNotificationsModal: closeNotificationsModal,
		getRoutes: getRoutes,
		openNotificationsModal: openNotificationsModal,
		routeHandler: routeHandler,
		toggleSidebar: toggleSidebar,
		openSiderbar: openSiderbar,
		clickListItem: clickListItem
	}),
	watch: {
		$route: routeHandler
	}
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_app_tooltip_button__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_inputs_base_input__ = __webpack_require__(228);




var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var dataUserInfo, params, _$route$params, subsidiaryId, subsidiaryName, id, currentSubsidiary, _currentSubsidiary;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						dataUserInfo = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
						params = {
							customerId: dataUserInfo ? dataUserInfo.subsidiary.customerId : null
						};
						_context.next = 4;
						return this.$loadSubsidiaries({ context: this, params: params });

					case 4:
						_$route$params = this.$route.params, subsidiaryId = _$route$params.subsidiaryId, subsidiaryName = _$route$params.subsidiaryName;

						if (subsidiaryId && subsidiaryName) {
							id = Number(subsidiaryId);
							currentSubsidiary = this.getGlobalSubsidiaries.find(function (sub) {
								return sub.id === id;
							});

							this.$setCurrentSubsidiary(currentSubsidiary);
						} else if (this.getGlobalSubsidiaries.length === 1) {
							_currentSubsidiary = this.getGlobalSubsidiaries.find(function (sub) {
								return sub.companyId != null;
							});

							this.$setCurrentSubsidiary(_currentSubsidiary);
						}

					case 6:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

var openModal = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var _ref3, user;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_ref3 = {}, user = _ref3.user;

						if (typeof this.$userInfo === 'string') {
							user = JSON.parse(this.$userInfo);
						} else {
							user = this.$userInfo;
						}
						this.idUserCompany = user.auxiliary.id;
						this.model.userName = user.auxiliary.userName;
						this.model.phone = user.auxiliary.phone;
						this.model.numberDocument = user.auxiliary.numberDocument;
						this.model.email = user.auxiliary.email;
						this.activateModal = true;
						this.showMenu = false;

					case 9:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function openModal() {
		return _ref2.apply(this, arguments);
	};
}();

var updateData = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.prev = 0;
						_context3.next = 3;
						return this.$http.patch('auxiliary/' + this.idUserCompany, this.model);

					case 3:
						this.showNotification('Contador actualizado correctamente. Para ver los cambios es necesario reinicar sesión');
						_context3.next = 9;
						break;

					case 6:
						_context3.prev = 6;
						_context3.t0 = _context3['catch'](0);

						this.showGenericError();

					case 9:
						_context3.prev = 9;

						this.closeModal();
						return _context3.finish(9);

					case 12:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[0, 6, 9, 12]]);
	}));

	return function updateData() {
		return _ref4.apply(this, arguments);
	};
}();

var logout = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						window.localStorage.clear();
						_context4.next = 3;
						return this.$httpAcl.post('logout', {
							headers: {
								authorization: 'Bearer ' + this.token
							}
						});

					case 3:
						this.$clearUser();
						this.$router.push({ name: 'login' });

					case 5:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function logout() {
		return _ref5.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function openNotifications() {
	this.$emit('open-notifications-event');
}

function closeModal() {
	this.activateModal = !this.activateModal;
}

function goToNewCompany() {
	if (this.$route.name === 'companies') {
		this.goTo('company-new', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.params) });
	} else {
		this.goTo('company-new');
	}
}

function noSubsidiarySelected() {
	return !(this.currentSubsidiary && this.currentSubsidiary.name);
}

function getRoute(_ref6) {
	var route = _ref6.route;

	if (!this.noSubsidiarySelected) {
		if (route === 'costs-centers') {
			var _currentSubsidiary2 = this.currentSubsidiary,
			    id = _currentSubsidiary2.id,
			    name = _currentSubsidiary2.name;

			return { name: route, query: { subsidiaryId: id, subsidiaryName: name.split(' ').join('-') } };
		} else if (route === 'accounting-modules') {
			var _currentSubsidiary3 = this.currentSubsidiary,
			    _id = _currentSubsidiary3.id,
			    _name = _currentSubsidiary3.name,
			    customerId = _currentSubsidiary3.customerId;

			return { name: 'accounting-modules', query: { subsidiaryId: _id, name: _name, customerId: customerId } };
		} else if (route === 'accounting-periods') {
			var _currentSubsidiary4 = this.currentSubsidiary,
			    subsidiaryId = _currentSubsidiary4.id,
			    _name2 = _currentSubsidiary4.name;

			var subsidiaryName = _name2.split(' ').join('-');
			return { name: 'accounting-periods', params: { subsidiaryId: subsidiaryId, subsidiaryName: subsidiaryName } };
		} else if (route === 'accounting-plans') {
			var _id2 = this.currentSubsidiary.id;

			return { name: 'accounting-plans', params: { subsidiaryId: _id2 } };
		}
	}
	return '';
}

function data() {
	return {
		showMenu: false,
		shortcuts: [{ icon: '/static/img/icons/centro-costos.svg', title: 'Centro de costos', route: 'costs-centers' }, { icon: '/static/img/icons/plan-contable.svg', title: 'Plan contable', route: 'accounting-plans' }, { icon: '/static/img/icons/periodo-contable.svg', title: 'Periodos contables', route: 'accounting-periods' }, { icon: '/static/img/icons/modulo.svg', title: 'Modulos', route: 'accounting-modules' }],
		activateModal: false,
		model: {
			userName: null,
			phone: null,
			numberDocument: null,
			email: null
		},
		idUserCompany: null
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-header',
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_4__components_shared_app_tooltip_button__["a" /* default */],
		HeaderSelect: function HeaderSelect() {
			return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 722));
		},
		baseInput: __WEBPACK_IMPORTED_MODULE_5__components_shared_inputs_base_input__["default"]
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['userAvatar', 'userName']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('subsidiary', ['currentSubsidiary', 'getGlobalSubsidiaries']), {
		noSubsidiarySelected: noSubsidiarySelected
	}),
	created: created,
	data: data,
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', {
		$clearUser: 'clearUser'
	}), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('subsidiary', {
		$setCurrentSubsidiary: 'setCurrentSubsidiary',
		$loadSubsidiaries: 'loadSubsidiaries'
	}), {
		getRoute: getRoute,
		logout: logout,
		openNotifications: openNotifications,
		goToNewCompany: goToNewCompany,
		openModal: openModal,
		closeModal: closeModal,
		updateData: updateData
	}),
	props: {
		quantityNotifications: {
			default: 0,
			type: Number
		},
		mini: Boolean
	}
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_helper__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(20);





var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this = this;

		var response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return this.$httpAcl.get('sidebar/' + 'quipu-admin');

					case 3:
						response = _context.sent;

						this.items = response.data.data.map(function (item) {
							var newItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, item);
							if (item.id === 149) {
								newItem.pathIcon = 'https://maki-static.s3.amazonaws.com/3eqm71hx_image/DAVJF_0501662316001/principal-44.png';
							} else if (item.id === 129) {
								newItem.pathIcon = 'https://maki-static.s3.amazonaws.com/3eqm71hx_image/DAVJF_0501662316001/ecommerce97.png';
							}
							if (item.resource.data.length === 0) {
								if (item.uri === _this.$route.path) {
									newItem.active = true;
								}
							} else {
								item.resource.data.forEach(function (src) {
									if (src.uri === _this.$route.path || '/' + src.uri === _this.$route.path) {
										newItem.active = true;
									}
								});
								item.resource.data.sort(function (a, b) {
									return a.position - b.position;
								});
							}
							return newItem;
						}).sort(function (a, b) {
							return a.position - b.position;
						});
						__WEBPACK_IMPORTED_MODULE_4__shared_helper__["a" /* default */].setLocalData('sidebar', this.items);
						this.$emit('active-route', this.items);
						localStorage.setItem('sidebarApp', this.items);
						_context.next = 13;
						break;

					case 10:
						_context.prev = 10;
						_context.t0 = _context['catch'](0);

						this.$store.showSnackBar({
							color: 'error',
							text: 'Error interno, recargue la página e intente de nuevo'
						});

					case 13:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 10]]);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	this.widthIcon();
	var iconOpen = Object({"NODE_ENV":"production","APP_CODE":'quipu-admin',"APP_NAME":'"Maki-Contable"',"QUIPU_URL":'https://ec-motor.makipos.la',"SALES_URL":'https://ec-pre-sales.makipos.la/',"MOCK_URL":'https://jsonplaceholder.typicode.com',"ACL_URL":'https://ec-acl.makipos.la/api',"COMPANY_FAVICON":'/static/img/icons/favicon-32x32.png',"EXCEL_EXPORT":'/static/',"PRODUCTS_URL":'https://ec-pre-products.makipos.la/',"PRODUCTION_URL":'https://ec-production.makipos.la/',"STORAGE_USER_KEY":"quipu","S3_IMAGES_URL":'//s3.amazonaws.com/apprunn-acl/icons',"COMPANY_LOGIN_TITLE":'Quipu'}).LOGO_SIDEBAR;
	var iconClose = Object({"NODE_ENV":"production","APP_CODE":'quipu-admin',"APP_NAME":'"Maki-Contable"',"QUIPU_URL":'https://ec-motor.makipos.la',"SALES_URL":'https://ec-pre-sales.makipos.la/',"MOCK_URL":'https://jsonplaceholder.typicode.com',"ACL_URL":'https://ec-acl.makipos.la/api',"COMPANY_FAVICON":'/static/img/icons/favicon-32x32.png',"EXCEL_EXPORT":'/static/',"PRODUCTS_URL":'https://ec-pre-products.makipos.la/',"PRODUCTION_URL":'https://ec-production.makipos.la/',"STORAGE_USER_KEY":"quipu","S3_IMAGES_URL":'//s3.amazonaws.com/apprunn-acl/icons',"COMPANY_LOGIN_TITLE":'Quipu'}).LOGO_SIDEBAR_CLOSE;
	this.iconOpen = iconOpen || 'https://maki-acl.s3.amazonaws.com/iconosNew/icon-makipos2.png';
	this.iconClose = iconClose || '	https://maki-acl.s3.amazonaws.com/iconosNew/icon-ocult-makipos.png';
	this.loadData();
}
function nameRoute() {
	return this.isMibodega ? 'dashboard-report' : 'main';
}

function openMenu() {}
function widthIcon() {
	return this.iconOpen ? '110px' : '65px';
}
function data() {
	return {
		drawer: true,
		items: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-sidebar',
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('user', ['userAvatarSideBar', 'userName']), {
		nameRoute: nameRoute
	}),
	created: created,
	data: data,
	methods: {
		loadData: loadData,
		openMenu: openMenu,
		widthIcon: widthIcon
	},
	props: {
		mini: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'form-sidebar'
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_app_button__ = __webpack_require__(246);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function cancelModal() {
	this.$emit('cancel-button-clicked');
}

function setInfo() {
	this.$emit('accept-button-clicked');
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'modal-sidebar-button',
	components: {
		appButton: __WEBPACK_IMPORTED_MODULE_0__components_shared_app_button__["default"]
	},
	methods: {
		cancelModal: cancelModal,
		setInfo: setInfo
	},
	props: {
		isLoading: {
			default: false,
			type: Boolean
		},
		hidden: {
			type: Boolean,
			default: false
		},
		hiddenSaveBtn: {
			type: Boolean,
			default: false
		},
		successColor: {
			default: 'success',
			type: String
		},
		successImg: {
			default: 'icon-apply.svg',
			type: String
		},
		successText: {
			default: 'Aceptar',
			type: String
		}
	}
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function downloadDocument(option) {
	if (this.showReportMenu) {
		if (this.disabledOption && option.id === 2) {
			return;
		}
		this.$emit('emit-report', option.code);
	}
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-button-list',
	methods: {
		downloadDocument: downloadDocument
	},
	props: {
		openOnClick: {
			deafult: true,
			type: Boolean
		},
		options: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		img: {
			type: String,
			default: ''
		},
		showReportMenu: {
			default: false,
			type: Boolean
		},
		disabledOption: {
			default: false,
			type: Boolean
		}
	}
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_input_vue__ = __webpack_require__(215);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b8fedce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_input_vue__ = __webpack_require__(644);
function injectStyle (ssrContext) {
  __webpack_require__(643)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b8fedce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_base_input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b8fedce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_base_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_sidebar_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f26976a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_sidebar_vue__ = __webpack_require__(639);
function injectStyle (ssrContext) {
  __webpack_require__(638)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f26976a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f26976a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_bar_vue__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f1f7b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_bar_vue__ = __webpack_require__(635);
function injectStyle (ssrContext) {
  __webpack_require__(631)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07f1f7b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_bar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f1f7b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_button_vue__ = __webpack_require__(216);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47732f18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_button_vue__ = __webpack_require__(657);
function injectStyle (ssrContext) {
  __webpack_require__(656)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47732f18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47732f18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e786f704_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_vue__ = __webpack_require__(685);
function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e786f704"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e786f704_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_page_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a26e970_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_page_vue__ = __webpack_require__(679);
function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a26e970"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_page_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a26e970_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_general_filter_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33c62bb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_general_filter_vue__ = __webpack_require__(681);
function injectStyle (ssrContext) {
  __webpack_require__(680)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33c62bb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_general_filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33c62bb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_general_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_column_item_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6653cc15_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_column_item_vue__ = __webpack_require__(684);
function injectStyle (ssrContext) {
  __webpack_require__(683)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6653cc15"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_column_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6653cc15_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_column_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 261 */,
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_shortkey__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_the_mask__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_pivottable__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_pivottable_dist_vue_pivottable_css__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_pivottable_dist_vue_pivottable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_pivottable_dist_vue_pivottable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_updateOnReload__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_normalize_css__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_format__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__vuetify__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__http_index__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__axios__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__router__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_global__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__filters_global__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__global_components__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store__ = __webpack_require__(172);



var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.$bus.$on('USER_INFO', function (user) {
							__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$userInfo = user;
						});
						this.$http.interceptors.request.use(this.httpRequestInterceptor);
						this.$http.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpAcl.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpAcl.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpSales.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpSales.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpProducts.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpProducts.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpProduction.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpProduction.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

/* eslint-disable no-new */









// import treeNodesDl from 'tree-nodes-dl';













__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_pivottable__["b" /* default */]);
// Vue.use(treeNodesDl);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_analytics___default.a, {
	id: 'UA-XXXXXXX-1',
	autoTracking: {
		screenview: true
	},
	disableScriptLoader: true,
	sendHitTask: window.location.hostname === 'admin.quipu.com'
});

var userInfo = JSON.parse(localStorage.getItem("quipu" + '::adminUser'));
var router = Object(__WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_vue__["default"]);
Object(__WEBPACK_IMPORTED_MODULE_18__filters_global__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_vue__["default"]);
Object(__WEBPACK_IMPORTED_MODULE_13__vuetify__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_vue__["default"]);
Object(__WEBPACK_IMPORTED_MODULE_15__axios__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_vue__["default"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$today = __WEBPACK_IMPORTED_MODULE_11_date_fns_format___default()(new Date(), 'YYYY-MM-DD');
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$bus = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]();
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$imageUrl = '//s3.amazonaws.com/apprunn-acl/icons';
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$userInfo = userInfo;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_17__mixins_global__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
	created: created,
	el: '#app',
	methods: {
		httpRequestInterceptor: __WEBPACK_IMPORTED_MODULE_14__http_index__["a" /* httpRequestInterceptor */],
		httpResponseInterceptor: __WEBPACK_IMPORTED_MODULE_14__http_index__["b" /* httpResponseInterceptor */],
		httpResponseSuccessInterceptor: __WEBPACK_IMPORTED_MODULE_14__http_index__["c" /* httpResponseSuccessInterceptor */]
	},
	mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_updateOnReload__["a" /* default */]],
	router: router,
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_12__App__["a" /* default */]);
	},
	store: __WEBPACK_IMPORTED_MODULE_20__store__["a" /* default */]
});

/***/ }),
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */,
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(20);



function created() {
	var breadCrumbs = JSON.parse(localStorage.getItem('bc'));
	if (breadCrumbs) {
		this.$updateBreadCrumbsFromLocalStorage(breadCrumbs);
	}
	var currentSubsidiary = JSON.parse(localStorage.getItem('cs'));
	if (currentSubsidiary) {
		this.$setCurrentSubsidiary(currentSubsidiary);
	}
}

/* harmony default export */ __webpack_exports__["a"] = ({
	created: created,
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('subsidiary', {
		$setCurrentSubsidiary: 'setCurrentSubsidiary'
	}), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('route', {
		$updateBreadCrumbsFromLocalStorage: 'LOCAL_STORAGE_BREAD_CRUMBS'
	}))
});

/***/ }),
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */,
/* 301 */,
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(135);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd8e960a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(304);
function injectStyle (ssrContext) {
  __webpack_require__(303)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd8e960a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view'),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":5000,"color":_vm.snackbar.color,"top":true,"right":true},model:{value:(_vm.snackbar.isVisible),callback:function ($$v) {_vm.$set(_vm.snackbar, "isVisible", $$v)},expression:"snackbar.isVisible"}},[_vm._v("\n\t\t"+_vm._s(_vm.snackbar.text)+"\n\t\t"),_c('v-btn',{staticClass:"white--text",attrs:{"flat":""},nativeOn:{"click":function($event){_vm.snackbar.isVisible = false}}},[_vm._v("Cerrar")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_src_stylus_app_styl__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_src_stylus_app_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_src_stylus_app_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VAutocomplete__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VTabs__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTextarea__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTextarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTextarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VStepper__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VStepper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VSwitch__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VTreeview__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VTreeview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VTreeview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VPagination__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VPagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VPagination__);









































/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	Vue.use(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify___default.a, {
		components: {
			VAlert: __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert___default.a,
			VApp: __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp___default.a,
			VAutocomplete: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VAutocomplete___default.a,
			VBtn: __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn___default.a,
			VBtnToggle: __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle___default.a,
			VCheckbox: __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox___default.a,
			VChip: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip___default.a,
			VCard: __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard___default.a,
			VDataIterator: __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator___default.a,
			VDatePicker: __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker___default.a,
			VDialog: __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog___default.a,
			VDivider: __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider___default.a,
			VForm: __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm___default.a,
			VGrid: __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid___default.a,
			VIcon: __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon___default.a,
			VList: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList___default.a,
			VMenu: __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu___default.a,
			VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer___default.a,
			VRadioGroup: __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup___default.a,
			VSelect: __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect___default.a,
			VSlider: __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider___default.a,
			VSnackbar: __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar___default.a,
			VSubheader: __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader___default.a,
			VTextField: __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField___default.a,
			VTimePicker: __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker___default.a,
			VToolbar: __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar___default.a,
			VTooltip: __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip___default.a,
			transitions: __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions___default.a,
			VExpansionPanel: __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel___default.a,
			VDataTable: __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable___default.a,
			VProgressLinear: __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear___default.a,
			VTabs: __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VTabs___default.a,
			VTextarea: __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTextarea___default.a,
			VStepper: __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VStepper___default.a,
			VSwitch: __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VSwitch___default.a,
			VTreeview: __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VTreeview___default.a,
			VPagination: __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VPagination___default.a
		},
		theme: {
			primary: '#E0E5E8',
			secondary: '#006edb',
			accent: '#005CAF',
			error: '#f42b17',
			info: '#2DB6F5',
			success: '#00ca9d',
			warning: '#FFB74C',
			pink: '#fe6b7d',
			grey: '#e6eef1',
			cyan: '#00add4',
			white: '#ffffff',
			blue: '#006edb',
			red: '#ff0000'
		}
	});
});

/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */,
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */,
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */,
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */,
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */,
/* 349 */,
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */,
/* 352 */,
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */,
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */,
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */,
/* 366 */,
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */,
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */,
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */,
/* 377 */,
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */,
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */,
/* 392 */,
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */,
/* 399 */,
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */,
/* 408 */,
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */,
/* 412 */,
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */,
/* 420 */,
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */,
/* 432 */,
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */,
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */,
/* 437 */,
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */,
/* 440 */,
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */,
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */,
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */,
/* 448 */,
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */,
/* 456 */,
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */,
/* 470 */,
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */,
/* 492 */,
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = httpRequestInterceptor;
/* harmony export (immutable) */ __webpack_exports__["c"] = httpResponseSuccessInterceptor;
/* harmony export (immutable) */ __webpack_exports__["b"] = httpResponseInterceptor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__errors__ = __webpack_require__(607);




function httpRequestInterceptor(config) {
	var headers = config.headers;
	var token = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['user/token'];
	if (token) {
		headers.common.Authorization = 'Bearer ' + token;
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('toggleLoading', true);
	} else {
		this.$router.push('login');
	}
	return config;
}

function httpResponseSuccessInterceptor(response) {
	__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('toggleLoading', false);
	return response;
}

function httpResponseInterceptor(error) {
	__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('toggleLoading', false);
	var text = 'Su sesión expiró.';
	var status = error.response ? error.response.status : null;
	var loginRoute = { name: 'login' };
	if (status === 401) {
		this.$router.push(loginRoute);
	} else if (status === 400) {
		text = Object(__WEBPACK_IMPORTED_MODULE_2__errors__["a" /* default */])(error.response);
	} else if (status === 403) {
		text = 'No tiene suficientes permisos para realizar ésta acción';
	} else if (status === 500) {
		text = 'No se logró completar la acción, intente de nuevo.';
	}
	__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('showSnackBar', { text: text, color: 'error' });
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
}

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);


function toggleLoading(context, value) {
	context.commit('toggleLoading', value);
}

function showSnackBar(context, snackbar) {
	var visibleSnackBar = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, snackbar);
	visibleSnackBar.isVisible = true;
	visibleSnackBar.color = visibleSnackBar.color || 'primary';
	context.commit('showSnackBar', visibleSnackBar);
}

var methods = {
	showSnackBar: showSnackBar,
	toggleLoading: toggleLoading
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function indeterminate(state) {
	return state.appConfig.isLoading;
}

function snackbar(state) {
	return state.appConfig.snackbar;
}

var methods = {
	indeterminate: indeterminate,
	snackbar: snackbar
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);


function showSnackBar(state, snackbar) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.appConfig, 'snackbar', snackbar);
}

function toggleLoading(state, value) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.appConfig, 'isLoading', value);
}

var methods = {
	showSnackBar: showSnackBar,
	toggleLoading: toggleLoading
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_helper__ = __webpack_require__(45);



var userModule = {
	actions: {
		clearUser: function clearUser(_ref) {
			var commit = _ref.commit;

			commit('clearUser');
		},
		setToken: function setToken(_ref2, token) {
			var commit = _ref2.commit;

			commit('setToken', token);
		},
		setUser: function setUser(_ref3, user) {
			var commit = _ref3.commit;

			commit('setUser', user);
		}
	},
	getters: {
		userName: function userName(state) {
			return state.userName;
		},
		token: function token(state) {
			return state.token;
		},
		userAvatar: function userAvatar(state) {
			return state.profileImage || state.profileImageDefault;
		},
		userAvatarSideBar: function userAvatarSideBar(state) {
			return state.profileImage || state.profileImageDefaultSideBar;
		}
	},
	mutations: {
		clearUser: function clearUser(state) {
			__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'token', null);
			__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'user', null);
		},
		setToken: function setToken(state, token) {
			__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'token', token);
		},
		setUser: function setUser(state, user) {
			__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'user', user);
			__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'userName', user.name || user.email || 'Nombre de Usuario');
		}
	},
	state: {
		email: '',
		logo: 'quipu-logo.svg',
		profileImage: '',
		profileImageDefault: '/static/img/icons/icono-profile-azul.svg',
		profileImageDefaultSideBar: '/static/img/sidebar/avatar_default.svg',
		token: __WEBPACK_IMPORTED_MODULE_1__shared_helper__["a" /* default */].getLocalToken(),
		userName: '',
		user: {}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (userModule);

/***/ }),
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);




var userModule = {
	actions: {
		SET_BREAD_CRUMBS: function SET_BREAD_CRUMBS(_ref, _ref2) {
			var commit = _ref.commit,
			    state = _ref.state;
			var fromRoute = _ref2.fromRoute,
			    toRoute = _ref2.toRoute,
			    onlyRoute = _ref2.onlyRoute;

			localStorage.removeItem('bc');
			var existingIndex = state.breadCrumbs.findIndex(function (route) {
				return route.name === toRoute.name;
			});
			var newBreadCrumbs = [];
			if (onlyRoute || toRoute.name === 'customers' || toRoute.name === 'accounting-accounts-by-subsidiary') {
				newBreadCrumbs = [toRoute];
				commit('SET_BREAD_CRUMBS', newBreadCrumbs);
			} else if (existingIndex === -1) {
				var toConcat = fromRoute.name === 'customers' ? fromRoute : state.breadCrumbs;
				newBreadCrumbs = [].concat(toConcat, toRoute);
				commit('SET_BREAD_CRUMBS', newBreadCrumbs);
			} else {
				var breadCrumbsSliced = state.breadCrumbs.slice(0, existingIndex + 1);
				newBreadCrumbs = [].concat(breadCrumbsSliced);
				commit('SET_BREAD_CRUMBS', newBreadCrumbs);
			}
			localStorage.setItem('bc', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newBreadCrumbs));
		},
		LOCAL_STORAGE_BREAD_CRUMBS: function LOCAL_STORAGE_BREAD_CRUMBS(_ref3, routeArray) {
			var commit = _ref3.commit;

			commit('SET_BREAD_CRUMBS', [].concat(routeArray));
		},
		UPDATE_BREAD_CRUMBS: function UPDATE_BREAD_CRUMBS(_ref4, currentSub) {
			var commit = _ref4.commit,
			    getters = _ref4.getters;

			var updatedBreadCrumbs = getters.getBreadCrumbs.reduce(function (list, item) {
				if (item.params.subsidiaryId) {
					var id = currentSub.id,
					    name = currentSub.name;

					var newItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
					newItem.params.subsidiaryId = id;
					newItem.params.subsidiaryName = name.split(' ').join('-');
					return list.concat(newItem);
				}
				return list.concat(item);
			}, []);
			commit('SET_BREAD_CRUMBS', [].concat(updatedBreadCrumbs));
		}
	},
	getters: {
		getBreadCrumbs: function getBreadCrumbs(state) {
			return state.breadCrumbs;
		}
	},
	mutations: {
		SET_BREAD_CRUMBS: function SET_BREAD_CRUMBS(state, routeArray) {
			__WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'breadCrumbs', routeArray);
		}
	},
	state: {
		breadCrumbs: []
	}
};

/* harmony default export */ __webpack_exports__["a"] = (userModule);

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);







var subsidiaryModule = {
	actions: {
		loadSubsidiaries: function loadSubsidiaries(_ref, _ref2) {
			var _this = this;

			var commit = _ref.commit;
			var context = _ref2.context,
			    params = _ref2.params;
			return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
				var _ref3, subsidiaries;

				return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return context.$http.get('subsidiary', { params: params });

							case 2:
								_ref3 = _context.sent;
								subsidiaries = _ref3.data;

								commit('setSubsidiaries', [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(subsidiaries)));

							case 5:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		loadAccountingPeriod: function loadAccountingPeriod(_ref4, _ref5) {
			var _this2 = this;

			var commit = _ref4.commit;
			var context = _ref5.context,
			    params = _ref5.params;
			return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var _ref6, periods;

				return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return context.$http.get('period-con', { params: params });

							case 2:
								_ref6 = _context2.sent;
								periods = _ref6.data;

								commit('setAccountingPeriods', [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(periods)));

							case 5:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		setCurrentSubsidiary: function setCurrentSubsidiary(store, currentSubsidiary) {
			var subsidiary = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, currentSubsidiary);
			var newSubsidiary = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, subsidiary);
			localStorage.setItem('newSubsidiary', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newSubsidiary));
			localStorage.setItem('cs', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(subsidiary));
			store.commit('setCurrentSubsidiary', subsidiary);
			store.dispatch('route/UPDATE_BREAD_CRUMBS', subsidiary, { root: true });
		},
		updateSubsidiaries: function updateSubsidiaries(_ref7, subsidiaries) {
			var commit = _ref7.commit;

			commit('setSubsidiaries', [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(subsidiaries)));
		}
	},
	getters: {
		companyLogo: function companyLogo(state, getters, rootState) {
			return rootState.user ? rootState.user.logo : '';
		},
		currentSubsidiary: function currentSubsidiary(state) {
			return state.currentSubsidiary;
		},
		getAccountingPeriod: function getAccountingPeriod(state) {
			return state.accountingPeriod;
		},
		getSubsidiaries: function getSubsidiaries(state) {
			return state.subsidiaries;
		},
		getGlobalSubsidiaries: function getGlobalSubsidiaries(state) {
			/* const defaultSub = { id: null, name: 'Seleccione una empresa.' };
   return [].concat(defaultSub, state.subsidiaries); */
			return state.subsidiaries;
		}
	},
	mutations: {
		setCurrentSubsidiary: function setCurrentSubsidiary(state, subsidiary) {
			__WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'currentSubsidiary', subsidiary);
		},
		setSubsidiaries: function setSubsidiaries(state, subsidiaries) {
			__WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'subsidiaries', subsidiaries);
		},
		setAccountingPeriods: function setAccountingPeriods(state, accounting) {
			__WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'accountingPeriod', accounting);
		}
	},
	state: {
		accountingPeriod: [],
		currentSubsidiary: {},
		subsidiaries: []
	}
};

/* harmony default export */ __webpack_exports__["a"] = (subsidiaryModule);

/***/ }),
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);






var costCenterModule = {
	actions: {
		loadCostCenter: function loadCostCenter(store, _ref) {
			var _this = this;

			var context = _ref.context,
			    subsidiaryId = _ref.subsidiaryId;
			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var _ref2, costsCenter;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return context.$http.get('cost-center/' + subsidiaryId + '/subsidiary');

							case 2:
								_ref2 = _context.sent;
								costsCenter = _ref2.data;

								costsCenter = costsCenter.map(function (c) {
									var newCost = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, c);
									var index = c.costCenterId ? costsCenter.findIndex(function (o) {
										return o.id === c.costCenterId;
									}) : -1;
									newCost.fatherAccount = index > -1 ? costsCenter[index].name : null;
									return newCost;
								});
								store.commit('setCostsCenter', [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(costsCenter)));

							case 6:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		}
	},
	getters: {
		getCostsCenters: function getCostsCenters(state) {
			return state.costsCenters;
		}
	},
	mutations: {
		setCostsCenter: function setCostsCenter(state, costsCenters) {
			__WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'costsCenters', costsCenters);
		}
	},
	state: {
		costsCenters: []
	}
};

/* harmony default export */ __webpack_exports__["a"] = (costCenterModule);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (code) {
	if (code === 'USER_EXISTS') {
		return 'El usuario ya existe';
	}
	return 'Verifique que completó los datos requeridos';
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var aclInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://ec-acl.makipos.la/api'
});

var quipuInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://ec-motor.makipos.la'
});

var salesInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://ec-pre-sales.makipos.la/'
});
var productsInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://ec-pre-products.makipos.la/'
});

var productionInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://ec-production.makipos.la/'
});

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	/* eslint-disable no-param-reassign */
	Vue.prototype.$httpAcl = aclInstance;
	Vue.prototype.$http = quipuInstance;
	Vue.prototype.$httpSales = salesInstance;
	Vue.prototype.$httpProducts = productsInstance;
	Vue.prototype.$httpProduction = productionInstance;
});

/***/ }),
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__login__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customers__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__customers_edit__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__customers_new__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__account_definitions__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__companies__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__companies_new__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__companies_edit__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__accounting_plans__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rules__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__accounting_parametrization__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__accounting_periods__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__accounting_rules_new__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__accounting_accounts__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__dictionary__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__cost_centers__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__accounting_rules_edit__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__journal__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__records__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__records_detail__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ledger__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__accounting_accounts_by_subsidiary__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__accouting_action__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__new_cost_center__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__edit_accounting__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__main__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__statistics__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reports__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__company_templates__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ats_sales__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ats_rules__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ats_rules_new__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__rules_ats_edit__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ats_list_dictionary__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__ats_dictionary__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__ats_definitions__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__batch_accounting__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__accounting_analysis__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__sync_odoo__ = __webpack_require__(696);















































/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	var _this = this;

	Vue.use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
	Vue.use(__WEBPACK_IMPORTED_MODULE_3_axios___default.a);
	var config = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
		mode: 'history',
		routes: [{
			path: '/',
			name: 'page-home',
			redirect: '/main',
			children: [__WEBPACK_IMPORTED_MODULE_40__ats_list_dictionary__["a" /* default */], __WEBPACK_IMPORTED_MODULE_41__ats_dictionary__["a" /* default */], __WEBPACK_IMPORTED_MODULE_42__ats_definitions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__accounting_plans__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__accouting_action__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__accounting_accounts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__accounting_parametrization__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__accounting_periods__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__accounting_rules_new__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__customers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__customers_edit__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__customers_new__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__dictionary__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__account_definitions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__companies__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__companies_new__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__companies_edit__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__modules__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__rules__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__cost_centers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__accounting_rules_edit__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__journal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__records__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__records_detail__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__ledger__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__accounting_accounts_by_subsidiary__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__new_cost_center__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__edit_accounting__["a" /* default */], __WEBPACK_IMPORTED_MODULE_32__main__["a" /* default */], __WEBPACK_IMPORTED_MODULE_33__statistics__["a" /* default */], __WEBPACK_IMPORTED_MODULE_34__reports__["a" /* default */], __WEBPACK_IMPORTED_MODULE_35__company_templates__["a" /* default */], __WEBPACK_IMPORTED_MODULE_37__ats_rules__["a" /* default */], __WEBPACK_IMPORTED_MODULE_36__ats_sales__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38__ats_rules_new__["a" /* default */], __WEBPACK_IMPORTED_MODULE_39__rules_ats_edit__["a" /* default */], __WEBPACK_IMPORTED_MODULE_43__batch_accounting__["a" /* default */], __WEBPACK_IMPORTED_MODULE_44__accounting_analysis__["a" /* default */], __WEBPACK_IMPORTED_MODULE_45__sync_odoo__["a" /* default */]],
			component: function component() {
				return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 762));
			}
		}, __WEBPACK_IMPORTED_MODULE_5__login__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__components__["a" /* default */]]
	});
	config.beforeEach(function () {
		var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
			var userData, response, user, inLocalStorage, _token, codeProject, headers, _ref2, current, currentInLocalStorage, token;

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							if (!(to.name !== 'login')) {
								_context.next = 30;
								break;
							}

							if (!(to.query && to.query.email && to.query.password)) {
								_context.next = 26;
								break;
							}

							/* localStorage.setItem(`${process.env.STORAGE_USER_KEY}::token`, to.query.token); */
							userData = {
								email: to.query.email,
								password: to.query.password,
								codeApp: 'quipu-admin'
							};
							_context.prev = 3;
							_context.next = 6;
							return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('https://ec-acl.makipos.la/api/authenticate', userData);

						case 6:
							response = _context.sent;
							user = response.data;
							inLocalStorage = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(user);
							_token = user.token, codeProject = user.codeProject;

							localStorage.setItem("quipu", inLocalStorage);
							localStorage.setItem("quipu" + '::codeProject', codeProject);
							localStorage.setItem("quipu" + '::token', _token);
							// this.$store.dispatch('setUser', token);
							headers = {
								Authorization: 'Bearer ' + _token
							};
							_context.next = 16;
							return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://ec-motor.makipos.la/company-token', { headers: headers });

						case 16:
							_ref2 = _context.sent;
							current = _ref2.data;
							currentInLocalStorage = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(current);

							localStorage.setItem("quipu" + '::adminUser', currentInLocalStorage);
							_this.$router.push({ name: 'main' });
							_context.next = 26;
							break;

						case 23:
							_context.prev = 23;
							_context.t0 = _context['catch'](3);

							// eslint-disable-next-line
							console.error(_context.t0);

						case 26:
							token = window.localStorage.getItem("quipu" + '::token');

							if (!token) {
								_context.next = 29;
								break;
							}

							return _context.abrupt('return', next());

						case 29:
							return _context.abrupt('return', next({ name: 'login' }));

						case 30:
							return _context.abrupt('return', next());

						case 31:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this, [[3, 23]]);
		}));

		return function (_x, _x2, _x3) {
			return _ref.apply(this, arguments);
		};
	}());
	return config;
});

/***/ }),
/* 628 */,
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/login',
	name: 'login',
	meta: {
		title: 'Quipu'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 723));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/customers',
	name: 'customers',
	meta: {
		noChangeCompany: true,
		title: 'Compañías'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 724));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fbc9212_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_vue__ = __webpack_require__(634);
function injectStyle (ssrContext) {
  __webpack_require__(633)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fbc9212"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fbc9212_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasHotKeys)?[_c('v-tooltip',{attrs:{"top":""}},[_c('template',{slot:"activator"},[_c('v-btn',_vm._b({directives:[{name:"shortkey",rawName:"v-shortkey",value:(_vm.hotKeys),expression:"hotKeys"}],staticClass:"btn-action-bar primary--text mx-0 my-1",attrs:{"small":""},on:{"click":_vm.openAction,"shortkey":_vm.openAction}},'v-btn',_vm.$attrs,false),[_c('v-tooltip',{staticClass:"new-indicator",attrs:{"top":""}},[(_vm.action.flagNew)?_c('v-icon',{attrs:{"slot":"activator","color":"info","size":"10"},slot:"activator"},[_vm._v("\n\t\t\t\t\t\t\tfiber_manual_record\n\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("¡Nuevo!")])],1),_vm._v(" "),(_vm.action.icon)?_c('v-icon',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.action.icon)+"\n\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.action.pathIcon)?_c('img',{staticClass:"img-action",attrs:{"src":_vm.action.pathIcon,"alt":_vm.action.name,"height":"19","width":"25"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"action-name"},[_vm._v(_vm._s(_vm.action.name))])],1)],1),_vm._v(" "),_c('span',[_vm._l((_vm.hotKeys),function(key,indexKey){return [_c('span',{key:indexKey},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(key)+"\n\t\t\t\t\t\t"),(indexKey !== (_vm.hotKeys.length - 1))?_c('span',[_vm._v(" + ")]):_vm._e()])]})],2)],2)]:[_c('v-btn',_vm._b({staticClass:"btn-action-bar primary--text mx-0 my-1",attrs:{"small":""},on:{"click":_vm.openAction}},'v-btn',_vm.$attrs,false),[_c('v-tooltip',{staticClass:"new-indicator",attrs:{"top":""}},[(_vm.action.flagNew)?_c('v-icon',{attrs:{"slot":"activator","color":"info","size":"10"},slot:"activator"},[_vm._v("\n\t\t\t\t\tfiber_manual_record\n\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("¡Nuevo!")])],1),_vm._v(" "),(_vm.action.icon)?_c('v-icon',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.action.icon)+"\n\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.action.pathIcon)?_c('img',{staticClass:"img-action",attrs:{"src":_vm.action.pathIcon,"alt":_vm.action.name,"height":"19","width":"25"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"action-name"},[_vm._v(_vm._s(_vm.action.name))])],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-bar-container",style:(("height: calc(44px * " + (_vm.actions.length) + ")"))},_vm._l((_vm.actions),function(action){return _c('action',{key:action.id,attrs:{"action":action,"disabled":action.disabled,"hot-keys":action.hotKeys},on:{"open-action":function($event){return _vm.openAction(action)}}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"my-0",style:(("width:" + _vm.width + "px")),attrs:{"slot":"activator","dark":"","flat":"","icon":"","disabled":_vm.disabled,"color":_vm.color},on:{"click":function($event){$event.preventDefault();return _vm.clickIcon.apply(null, arguments)}},slot:"activator"},[(_vm.icon)?[_c('v-icon',{style:(_vm.isListAll),attrs:{"color":_vm.color,"size":_vm.size}},[_vm._v(_vm._s(_vm.icon))])]:[_c('img',{attrs:{"src":_vm.img,"alt":"text"}})]],2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-navigation-drawer',{attrs:{"width":_vm.width,"right":"","temporary":"","fixed":"","stateless":true},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('section',{staticClass:"header-modal",style:(("background-color: " + _vm.headerColor))},[_c('header',{staticClass:"header-title"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',[_vm._t("options"),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","disabled":_vm.isLoading},on:{"click":_vm.closeDrawer}},[_c('v-icon',{staticClass:"iconClose",attrs:{"color":"#03A89E !important"}},[_vm._v("logout")])],1)],2)])]),_vm._v(" "),_c('section',{staticClass:"content-modal"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':id/edit',
	name: 'customers-edit',
	meta: {
		title: 'Editar Compañía'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 253));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 641 */,
/* 642 */,
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reduce-div",class:{ 'isLoading': _vm.isLoading }},[_c('transition-group',{attrs:{"name":"fade"}},[(!_vm.isLoading)?_c('v-text-field',_vm._b({key:"input",staticClass:"base-input",attrs:{"hide-details":"","background-color":"white","height":_vm.height,"value":_vm.value},on:{"input":_vm.sendValue,"blur":_vm.blurAction}},'v-text-field',_vm.$attrs,false)):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('span',{key:"error",staticClass:"error-style"},[_vm._t("error")],2):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: 'new',
	name: 'customer-new',
	meta: {
		title: 'Nueva Compañía'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 253));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/account-definitions',
	name: 'account-definitions',
	meta: {
		title: 'Lista de Definiciones'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 725));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':customerName?/:customerId?/companies',
	name: 'companies',
	meta: {
		title: 'Empresas'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 726));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var newCompany = {
	path: ':customerName?/:customerId?/companies/new',
	name: 'company-new',
	meta: {
		title: 'Nueva Empresa'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 254));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (newCompany);

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var editCompany = {
	path: ':customerName?/:customerId?/companies/edit/:companyId',
	name: 'company-edit',
	meta: {
		title: 'Editar Empresa'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 254));
	},
	props: true
};
/* harmony default export */ __webpack_exports__["a"] = (editCompany);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':subsidiaryId?/accountant',
	name: 'accounting-plans',
	meta: {
		title: 'LISTA PLAN DE CUENTAS'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 727));
	},
	props: true,
	children: [{
		name: 'activate-accounting-plan',
		path: ':yearAccountantId?/active',
		meta: {
			title: 'Activar Plan de Cuentas'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 728));
		},
		props: true
	}, {
		path: 'new',
		name: 'accounting-new',
		meta: {
			title: 'Nuevo Plan de Cuentas'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, 255));
		},
		props: true
	}, {
		path: ':id/edit',
		name: 'accounting-edit',
		meta: {
			title: 'Editar Plan de Cuentas'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, 255));
		},
		props: true
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/rules',
	name: 'accounting-rules',
	meta: {
		title: 'Lista de Reglas Contables'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 729));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':customerId?/companies/:subsidiaryId/accounting-parametrization',
	name: 'accounting-parametrization',
	meta: {
		title: 'Datos Iniciales Contables'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 730));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"app-btn ml-2",class:{ blue: _vm.blue, red: _vm.red, green: _vm.green, gray: _vm.gray },style:(_vm.style),attrs:{"type":"button"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n\t"+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':subsidiaryId/:subsidiaryName/accounting-periods',
	name: 'accounting-periods',
	meta: {
		title: 'Periodos Contables'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 731));
	},
	props: true,
	children: [{
		name: 'accounting-period-edit',
		path: ':id/edit',
		meta: {
			title: 'Editar Periodo Contable'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 732));
		},
		props: true
	}, {
		name: 'accounting-period-lock',
		path: ':id/lock',
		meta: {
			title: 'Bloquear Periodo Contable'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 733));
		},
		props: true
	}, {
		name: 'accounting-period-activate',
		path: ':code',
		meta: {
			title: 'Activar Periodo Contable'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 734));
		},
		props: true
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: 'accounting-rules/new',
	name: 'accounting-rules-new',
	meta: {
		title: 'Nueva Regla Contable'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 256));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/modules',
	name: 'accounting-modules',
	meta: {
		title: 'Lista de Módulos'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 735));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/accountant/:id/:name/:subsidiaryName/:year/accounting-accounts',
	name: 'accounting-accounts',
	meta: {
		title: 'Cuentas Contables',
		noChangeCompany: true
	},
	component: function component() {
		return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 736));
	},
	props: true,
	children: [{
		path: 'new',
		name: 'accounting-account-new',
		meta: {
			title: 'Crear Cuenta Contable'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 72));
		},
		props: true
	}, {
		path: ':accountId/edit',
		name: 'accounting-account-edit',
		meta: {
			title: 'Editar Cuenta Contable'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 72));
		},
		props: true
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/dictionary',
	name: 'accounting-dictionary',
	meta: {
		title: 'Diccionario de Datos',
		noChangeCompany: true
	},
	component: function component() {
		return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 737));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: 'costs-centers',
	name: 'costs-centers',
	meta: {
		title: 'Centros de Costos'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 738));
	},
	props: true,
	children: [{
		path: 'new',
		name: 'cost-center-new',
		meta: {
			title: 'Nueva Centro de Costos'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, 257));
		},
		props: true
	}, {
		path: ':id/:fatherId/edit',
		name: 'cost-center-edit',
		meta: {
			title: 'Editar Centro de Costos'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, 257));
		},
		props: true
	}, {
		path: 'import',
		name: 'cost-center-import',
		meta: {
			title: 'Importar Centro de Costos'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 739));
		},
		props: true
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: 'accounting-rules/:id/edit',
	name: 'accounting-rules-edit',
	meta: {
		title: 'Editar Regla Contable'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 256));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':subsidiaryId?/journal',
	name: 'journal',
	meta: {
		title: 'Libro Diario'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 740));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':subsidiaryId/:subsidiaryName/accounting-periods/:periodId/records',
	name: 'records',
	meta: {
		title: 'REGISTROS',
		noChangeCompany: true
	},
	component: function component() {
		return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 741));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':subsidiaryId/:subsidiaryName/accounting-periods/:periodId/records/:id',
	name: 'records-detail',
	meta: {
		title: 'DETALLE',
		noChangeCompany: true
	},
	component: function component() {
		return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 742));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':subsidiaryId?/ledger',
	name: 'ledger',
	meta: {
		title: 'Libro Mayor'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 743));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/components',
	name: 'components',
	meta: {
		title: 'Componentes'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 744));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/accounting-accounts',
	name: 'accounting-accounts-by-subsidiary',
	meta: {
		title: 'Cuentas Contables'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 745));
	},
	children: [{
		path: 'new',
		name: 'accounting-account-by-subsidiary-new',
		meta: {
			title: 'Crear Cuenta Contable'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 72));
		},
		props: true
	}, {
		path: ':accountId/edit',
		name: 'accounting-account-by-subsidiary-edit',
		meta: {
			title: 'Editar Cuenta Contable'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 72));
		},
		props: true
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':subsidiaryId/:subsidiaryName/:periodId/accounting-action',
	name: 'page-accounting-action',
	meta: {
		title: 'Contabilización'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 746));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: 'new-cost-centers',
	name: 'center-of-cost',
	meta: {
		title: 'Centro de Costos'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 747));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':subsidiaryId/:moduleId/edit-accounting',
	name: 'page-edit-accounting',
	meta: {
		title: 'Editar Asiento'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 748));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/main',
	name: 'main',
	meta: {
		title: 'Principal'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 749));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/statistics',
	name: 'statistics',
	meta: {
		title: 'Estadisticas'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 750));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 676 */,
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: 'reports',
	name: '/reports',
	redirect: '/general',
	component: function component() {
		return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 751));
	},
	children: [{
		name: 'general-reports',
		path: '/general',
		meta: {
			title: 'Reportes Generales'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 752));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-header-page media-print",attrs:{"tabindex":"-6"}},[_c('div',{staticClass:"bread",attrs:{"tabindex":"-5"}},_vm._l((_vm.getBreadCrumbs),function(route,routeIndex){return _c('router-link',{key:routeIndex,staticClass:"header-page-title",attrs:{"tag":"h1","tabindex":"-1","to":{ name: route.name, params: route.params, query: route.query }}},[(_vm.width <= 768 && _vm.getBreadCrumbs.length >= 4)?[_vm._v("\n\t\t\t\t"+_vm._s(_vm._f("limitTo")(_vm.titleBreadCrumb(route),7))+"\n\t\t\t")]:[_vm._v("\n\t\t\t\t"+_vm._s(_vm.titleBreadCrumb(route))+"\n\t\t\t")]],2)}),1),_vm._v(" "),(_vm.toShow && _vm.width > 768)?_c('div',{staticClass:"header-page-actions",attrs:{"tabindex":"-1"}},[(_vm.exportToPdf)?_c('v-btn',{staticClass:"header-page-download-document primary mr-2",attrs:{"tabindex":"-1"},on:{"click":function($event){$event.preventDefault();return _vm.downloadDispatch.apply(null, arguments)}}},[_c('img',{staticClass:"align-img",attrs:{"src":(_vm.$imageUrl + "/icon-export-pdf.svg"),"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.showExcel)?_c('v-btn',{staticClass:"header-page-download-document primary",attrs:{"tabindex":"-1"},on:{"click":_vm.downloadDocument}},[_c('img',{attrs:{"src":(_vm.$imageUrl + "/fill-1.svg"),"alt":"download","height":"17"}})]):_vm._e(),_vm._v(" "),(_vm.showClean)?_c('v-btn',{staticClass:"btn-action",attrs:{"dark":"","color":"pink","tabindex":"-1"},on:{"click":function($event){return _vm.$emit('on-clean')}}},[_vm._v("\n\t\t\tLimpiar\n\t\t")]):_vm._e(),_vm._v(" "),_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.quotation || _vm.sale)?_c('div',{staticClass:"header-page-actions translate"},[_c('v-btn',{staticClass:"header-page-download-document",attrs:{"flat":"","tabindex":"-1"},on:{"click":_vm.downloadDocument}},[_c('img',{attrs:{"src":(_vm.$imageUrl + "/download.svg"),"alt":"download","height":"17"}})]),_vm._v(" "),_c('v-btn',{staticClass:"header-page-download-document",attrs:{"flat":"","tabindex":"-1"},on:{"click":_vm.print}},[_c('img',{attrs:{"src":(_vm.$imageUrl + "/print.svg"),"alt":"download","height":"17"}})])],1):_vm._e(),_vm._v(" "),(_vm.actions)?_c('div',{staticClass:"action-bar-header",attrs:{"tabindex":"-1"}},[_c('v-menu',{attrs:{"content-class":"menu-header-page","tabindex":"-1"}},[_c('v-btn',{staticClass:"btn-activator",attrs:{"slot":"activator","icon":"","tabindex":"-1"},slot:"activator"},[_c('v-icon',{attrs:{"color":"indigo darken-1"}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-card',[_c('action-bar',{attrs:{"value-disabled":_vm.valueDisabled,"resource-uri":_vm.$route.name,"tabindex":"-1"},on:{"run-action":_vm.openAction}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content-space-between",attrs:{"tabindex":"-1"}},[(_vm.detailJournalOpen)?_c('div',{staticClass:"header-detail-journal-mobile",attrs:{"tabindex":"-1"}},[_vm._v("\n\t\t\t# "+_vm._s(_vm.codeJournal)+" - "+_vm._s(_vm.dateJournal)+"\n\t\t")]):_vm._e(),_vm._v(" "),(_vm.searchHeader)?_c('div',{staticClass:"header-page-search",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"align-center",attrs:{"tabindex":"-1"}},[_c('transition',{attrs:{"name":"slide-fade","tabindex":"-1"}},[(_vm.show)?_c('div',{staticClass:"search-input",attrs:{"tabindex":"-1"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],attrs:{"placeholder":"Buscar...","type":"text","tabindex":"-1"},domProps:{"value":(_vm.search)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchRows.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.searchRows.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('v-icon',{staticClass:"icon-search-input"},[_vm._v("search")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"border-r",attrs:{"tabindex":"-1"}},[_c('v-btn',{staticClass:"btn-search",attrs:{"tabindex":"-1"},on:{"click":_vm.open}},[_c('img',{attrs:{"src":"/static/img/icons/search.svg","width":"17","height":"17","alt":""}})])],1)],1)]):_vm._e(),_vm._v(" "),(_vm.buttonDelete)?_c('div',{staticClass:"border-r",attrs:{"tabindex":"-1"}},[_c('v-btn',{staticClass:"btn-delete",attrs:{"tabindex":"-1"},on:{"click":function($event){return _vm.$emit('delete-journal')}}},[_c('img',{attrs:{"src":"/static/img/icons/backspace.svg","width":"17","height":"17px"}})])],1):_vm._e(),_vm._v(" "),(_vm.buttonFilter)?_c('div',{attrs:{"tabindex":"-1"}},[_c('v-btn',{staticClass:"btn-filter",attrs:{"tabindex":"-1"},on:{"click":function($event){return _vm.$emit('click-filter')}}},[_c('img',{attrs:{"src":"/static/img/icons/filter.svg","width":"17","height":"17px"}})])],1):_vm._e(),_vm._v(" "),(_vm.buttonClose)?_c('div',{attrs:{"tabindex":"-1"}},[_c('v-btn',{staticClass:"btn-close",attrs:{"tabindex":"-1"},on:{"click":function($event){return _vm.$emit('click-close')}}},[_c('img',{attrs:{"src":"/static/img/sidebar/close.svg","width":"17","height":"17px"}})])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-filter media-print"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{class:{ 'large-title': _vm.column.largeTitle },attrs:{"id":'column-' + _vm.column.id}},[(_vm.column.isEditable)?_c('span',[(_vm.column.showInput)?_c('span',[_c('input',{ref:("colheader" + (_vm.column.id)),staticClass:"column-input",attrs:{"type":"text","placeholder":_vm.column.name},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggleInput(_vm.column)},"input":function($event){return _vm.$emit('column-input', { event: $event, column: _vm.column })}}})]):(_vm.column.tooltip)?_c('span',{staticClass:"column-edit-container"},[_c('v-tooltip',{attrs:{"top":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.column.name))]),_vm._v("\n\t\t\t\t"+_vm._s(_vm.column.tooltip)+"\n\t\t\t")]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.toggleInput(_vm.column)}}},[_c('img',{attrs:{"height":"11","title":"Editar todas las filas a la vez","width":"11","src":(_vm.$imageUrl + "/edit-table.svg")}})])],1):_c('span',{staticClass:"column-edit-container"},[_vm._v("\n\t\t\t"+_vm._s(_vm.column.name)+"\n\t\t\t"),_c('button',{on:{"click":function($event){return _vm.toggleInput(_vm.column)}}},[_c('img',{attrs:{"height":"11","title":"Editar todas las filas a la vez","width":"11","src":(_vm.$imageUrl + "/edit-table.svg")}})])])]):(_vm.column.tooltip)?_c('span',[_c('v-tooltip',{attrs:{"top":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.column.name))]),_vm._v("\n\t\t\t"+_vm._s(_vm.column.tooltip)+"\n\t\t")])],1):_c('span',[_vm._v("\n\t\t"+_vm._s(_vm.column.name)+"\n\t")]),_vm._v(" "),(_vm.column.isSortable)?_c('button',{staticClass:"sortable-button",on:{"click":function($event){return _vm.onColumnSortable(_vm.column)}}},[(_vm.column.isSortable.down)?_c('i',{staticClass:"sortable-icon material-icons icon"},[_vm._v("\n\t\t\tarrow_drop_down\n\t\t")]):_vm._e(),_vm._v(" "),(_vm.column.isSortable.up)?_c('i',{staticClass:"sortable-icon material-icons icon"},[_vm._v("\n\t\t\tarrow_drop_up\n\t\t")]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('table',{class:[
			'table-list' ],attrs:{"border":"0","cellpadding":"0","cellspacing":"0"}},[_c('thead',[(_vm.inputSearch || _vm.filterColumns || _vm.deleteSeat || _vm.includeFilter || _vm.addButton || _vm.editCont)?_c('tr',[_c('th',{class:[("text-xs-" + _vm.direction), 'movil-header-row'],attrs:{"colspan":_vm.totalVisibleColumns}},[(_vm.flagTitle)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"should-color",attrs:{"wrap":"","align-center":"","justify-center":""}},[_c('v-flex',[_c('div',{staticClass:"d-flex px-0 justify-center",attrs:{"font-weight-bold":""}},[_c('span',{staticClass:"debitV"},[_vm._v(_vm._s(_vm.title))])])])],1)],1):_vm._e(),_vm._v(" "),(_vm.clearFilter)?_c('button',{staticClass:"vertical-align-middle btn-clean-filter no-movil",attrs:{"type":"button"},on:{"click":_vm.tableClearFilter}},[_vm._v("\n\t\t\t\t\t\tLimpiar Filtro\n\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.includeFilter)?_c('button',{staticClass:"vertical-align-middle btn-filter no-movil",attrs:{"type":"button"},on:{"click":_vm.tableOption}},[_vm._v("\n\t\t\t\t\t Filtros\n\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.filterColumns)?_c('v-menu',{attrs:{"offset-y":"","nudge-left":97,"max-height":"300","content-class":"columns-menu","fixed":"","close-on-content-click":false},model:{value:(_vm.showMenu),callback:function ($$v) {_vm.showMenu=$$v},expression:"showMenu"}},[_c('button',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',[_vm._v("view_column")])],1),_vm._v(" "),_c('div',[_vm._l((_vm.columns),function(column){return [(!column.flagVisible)?_c('v-checkbox',{key:column.id,staticStyle:{"background":"white"},attrs:{"label":column.name,"hide-details":"","color":"success"},model:{value:(column.checked),callback:function ($$v) {_vm.$set(column, "checked", $$v)},expression:"column.checked"}}):_vm._e()]}),_vm._v(" "),_c('div',{staticClass:"apply text-xs-center"},[_c('button',{on:{"click":_vm.toggleColumns}},[_vm._v("Aplicar")])])],2)]):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.downButton)?_c('v-btn',{staticClass:"btn-auto pa-0 ma-2",attrs:{"slot":"activator","color":"success"},on:{"click":function($event){return _vm.$emit('download-format')}},slot:"activator"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("download")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Descargar Formato")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.showExcel)?_c('v-btn',{staticClass:"btn-auto pa-0 ma-2",attrs:{"slot":"activator","color":"success"},on:{"click":function($event){return _vm.$emit('import-excel')}},slot:"activator"},[_c('img',{attrs:{"src":'static/img/icons/excel.svg',"alt":"import_excel","height":_vm.height}})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Cargar Excel")])],1),_vm._v(" "),(_vm.editCont)?_c('v-btn',{staticClass:"btn-edit",attrs:{"target":"_blank","disabled":_vm.disabledEditAccou,"color":"blue"},on:{"click":function($event){return _vm.$emit('edit-accouting')}}},[_vm._v("\n\t\t\t\t\t\tEditar\n\t\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.deleteSeat)?_c('v-btn',{staticClass:"btn-auto pa-0 ma-2 btn-delete",attrs:{"slot":"activator","color":"red","type":"button"},on:{"click":_vm.openDeleteSeat},slot:"activator"},[_c('v-icon',{attrs:{"color":"white","size":"19"}},[_vm._v("\n\t\t\t\t\t\t\t\tdelete\n\t\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.tooltipDelete))])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.addIcon)?_c('v-btn',{staticClass:"btn-auto pa-0 ma-0 btn-add no-movil",attrs:{"slot":"activator","color":"#33cfc7","type":"button"},on:{"click":_vm.addAIconAction},slot:"activator"},[_c('v-icon',{attrs:{"color":"white","size":"19"}},[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.nameTooltip))])],1),_vm._v(" "),_vm._t("text"),_vm._v(" "),(_vm.addButton)?_c('button',{attrs:{"type":"button"},on:{"click":_vm.addOption}},[_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),(_vm.inputSearch)?_c('div',{staticClass:"search-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],attrs:{"type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchRows.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.searchRows.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('v-icon',[_vm._v("search")])],1):_vm._e()],2)]):_vm._e(),_vm._v(" "),_c('tr',{staticClass:"movil-table"},[(_vm.selectable)?_c('th',{class:{ 'hide-selectable-on-movil': _vm.hideSelectableOnMovil }},[_c('input',{staticClass:"input-checkbox",attrs:{"type":"checkbox"},domProps:{"value":_vm.checkAll,"checked":_vm.checkAll},on:{"change":function($event){return _vm.selectedAll($event)}}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(column){return _c("table-column-item",{directives:[{name:"show",rawName:"v-show",value:(column.visible),expression:"column.visible"}],key:column.id,tag:"th",class:[
						'text-xs-center',
						{ 'column-movil-version': !column.movil } ],attrs:{"column":column}})}),_vm._v(" "),(_vm.$route.name === 'center-of-cost' || _vm.$route.name === 'journal')?_c('th',{staticClass:"absolute-btn"},[_c('button',{staticClass:"btn-add-mobile",attrs:{"slot":"activator"},on:{"click":_vm.createAction},slot:"activator"},[_c('img',{attrs:{"src":"/static/img/icons/plus.svg","alt":"","width":"17","height":"17"}})])]):_vm._e()],2)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.rows),function(row,index){return _c('tr',{key:row[_vm.keyValue],class:[
						{ 'row-checked' : row.isSelected || row.isVisited },
						'movil-table' ],on:{"click":function($event){return _vm.rowIsSelected(row)}}},[(_vm.selectable)?_c('td',{staticClass:"check-row",class:{ 'hide-selectable-on-movil': _vm.hideSelectableOnMovil }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.isSelected),expression:"row.isSelected"}],staticClass:"input-checkbox",attrs:{"type":"checkbox","disabled":_vm.dispatchDetail && (row.flagDispatch > 0)},domProps:{"checked":Array.isArray(row.isSelected)?_vm._i(row.isSelected,null)>-1:(row.isSelected)},on:{"change":function($event){var $$a=row.isSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(row, "isSelected", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(row, "isSelected", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(row, "isSelected", $$c)}}}})]):_vm._e(),_vm._v(" "),_vm._t("rows",null,{"index":index,"row":row})],2)})],2),_vm._v(" "),(_vm.tFoot)?_c('tfoot',{staticClass:"table-pagination"},[(_vm.mainList && _vm.rows.length > 0)?_c('tr',[_c('td',{staticClass:"text-xs-right",attrs:{"colspan":_vm.totalVisibleColumns}},[(_vm.numberSeats)?[(_vm.numberSeats > 0)?_c('span',{staticClass:"mr-5 pr-5"},[_vm._v("# Asientos: "+_vm._s(_vm.numberSeats))]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.captionQuantity)?[_c('span',{staticClass:"caption-quantity pr-2"},[_vm._v(_vm._s(_vm.itemsQuantity)+" "),(_vm.captionQuantity)?_c('span',[_vm._v("de")]):_vm._e(),_vm._v(" "+_vm._s(_vm.itemsTotalQuantity))])]:_vm._e(),_vm._v(" "),_c('input',{staticClass:"search-input unique-input",attrs:{"type":"text"},domProps:{"value":_vm.currentPage},on:{"input":function($event){return _vm.selectPage($event.target.value)}}}),_vm._v(" "),_vm._l((_vm.pages),function(page,index){return _c('a',{key:index,class:{ 'active-page': page === _vm.currentPage },on:{"click":function($event){return _vm.selectPage(page)}}},[_vm._v(_vm._s(page))])}),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('a',{on:{"click":_vm.selectLastPage}},[_vm._v(">>")])],2)]):_vm._e(),_vm._v(" "),(_vm.rows.length === 0)?_c('tr',[(_vm.showAccounting)?_c('td',{style:(!_vm.mainList ?
						'border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;' :
						'border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;'),attrs:{"colspan":_vm.totalVisibleColumns}},[_c('p',{staticStyle:{"text-align":"center","margin":"150px 0 150px 0","color":"#a9bac2","font-weight":"600"}},[_vm._v("\n\t\t\t\t\t\tSelecciona un registro y contabiliza para que aparezcan los asientos\n\t\t\t\t\t")])]):(_vm.showRecord)?_c('td',{staticClass:"td-record",attrs:{"colspan":_vm.totalVisibleColumns}},[_c('p',{staticClass:"show-record"},[_vm._v("\n\t\t\t\t\t\tSeleccione un modulo para visualizar información\n\t\t\t\t\t")])]):_c('td',{style:(!_vm.mainList ?
						'border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;' :
						'border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;'),attrs:{"colspan":_vm.totalVisibleColumns}},[_c('p',{staticStyle:{"text-align":"center","margin":"5px 0 0 5px"}},[_vm._v("\n\t\t\t\t\t\tNo hay información que mostrar\n\t\t\t\t\t")])])]):_vm._e()]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/accouting-accounts-report',
	name: 'accouting-accounts-report',
	meta: {
		title: 'Reportes por Asignar'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 753));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/accouting-ats-sales',
	name: 'accouting-ats-sales',
	meta: {
		title: 'Anexos Transaccionales Generales'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 754));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/accouting-ats-rules',
	name: 'accouting-ats-rules',
	meta: {
		title: 'Reglas de Anexos Transaccionales'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 755));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: 'accounting-rules-ats/new',
	name: 'accounting-rules-ats-new',
	meta: {
		title: 'Nueva Regla Ats'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 261));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: 'rules-ats/:id/edit',
	name: 'rules-ats-edit',
	meta: {
		title: 'Editar Regla Ats'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 261));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/accounting-dictionary-ats',
	name: 'accounting-dictionary-ats',
	meta: {
		title: 'Diccionario de Datos Ats',
		noChangeCompany: true
	},
	component: function component() {
		return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 756));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/accouting-diccionary',
	name: 'accouting-diccionary',
	meta: {
		title: 'Diccionario Ats'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 757));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/accouting-definition',
	name: 'accouting-definition',
	meta: {
		title: 'Definiciones Ats'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 758));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'batch-accounting',
	path: 'batch-accounting',
	meta: {
		title: 'Contabilizar por lotes'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 759));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: 'accounting-analysis',
	name: 'accounting-analysis',
	meta: {
		title: 'Análisis Contable'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 760));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'sync-odoo',
	path: 'sync-odoo',
	meta: {
		title: 'Sincronización Odoo'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 761));
	},
	props: true
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);





var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(url) {
		var _ref2, records, headers;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return this.$http.get(url, { params: this.params });

					case 3:
						_ref2 = _context.sent;
						records = _ref2.data;
						headers = _ref2.headers;

						this.periods = records;
						this.table.lastPage = Number(headers['x-last-page']);
						this.table.itemTotal = Number(headers['x-quantity']);
						this.table.rows = records.map(function (record) {
							var newRecord = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, record);
							newRecord.isSelected = false;
							return newRecord;
						});
						return _context.abrupt('return', { records: records, headers: headers });

					case 13:
						_context.prev = 13;
						_context.t0 = _context['catch'](0);

						if (_context.t0.status === 400) {
							if (_context.t0.data.message === 'ACCOUNTANT_WITHOUT_CUSTOMERS') {
								this.showNotification('La cuenta no tiene clientes', 'warning');
							} else if (_context.t0.data.message === 'COM_ACCOUNTING_PLAN_ACTIVE_NOT_FOUND') {
								this.showGenericError('No se ha encontrado un plan de cuentas activo para la empresa seleeccionada.');
							}
						}

					case 16:
						_context.prev = 16;

						this.loadingAcc = false;
						return _context.finish(16);

					case 19:
						return _context.abrupt('return', {});

					case 20:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 13, 16, 19]]);
	}));

	return function loadData(_x) {
		return _ref.apply(this, arguments);
	};
}();

function data() {
	return {
		params: {
			customerId: null,
			page: 1,
			limit: 15,
			search: null
		},
		table: {
			lastPage: 1,
			rows: [],
			itemTotal: null
		},
		loadingAcc: false,
		periods: null
	};
}

function goTo(name, options) {
	this.$router.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ name: name }, options));
}

function getImageUrl(imageUrl) {
	return this.$imageUrl + '/' + imageUrl;
}

function onSearch(value, url) {
	this.params.search = value || null;
	this.params.page = 1;
	this.loadData(url);
}

function replaceString(word, selectionStart, newWord) {
	if (word) {
		return word.slice(0, selectionStart) + newWord + word.slice(selectionStart + 0);
	}
	return newWord;
}

function showNotification(text) {
	var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';

	this.$store.dispatch('showSnackBar', { text: text, color: color });
}

function showGenericError() {
	var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Ups, ocurrió algún problema';

	this.showNotification(text, 'error');
}

function showRow(columns, columnId) {
	var column = columns.find(function (h) {
		return h.id === columnId;
	});
	return column.visible;
}

function token() {
	return this.$store.getters['user/token'];
}

function stopClick() {
	return false;
}

function setLocalData(key, dataInfo) {
	return localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataInfo));
}

function labelsByCountry() {
	var user = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
	var company = user.company;
	var country = company.country;
	var geopositionPer = { lat: -12.0727971, lng: -77.0452889 };
	var geopositionEcu = { lat: -0.1764507, lng: -78.47527600000001 };
	var defaultCountry = {
		id: 1,
		name: 'Perú',
		code: 'PER',
		geoposition: geopositionPer
	};
	if (country) {
		return {
			id: country.id,
			code: country.countryCode,
			geoposition: country.countryCode === 'PER' ? geopositionPer : geopositionEcu,
			name: country.name
		};
	}
	return defaultCountry;
}

function isEcuador() {
	return this.labelsByCountry.id === 2;
}

function isPeru() {
	return this.labelsByCountry.id === 1;
}

var mixin = {
	data: data,
	computed: {
		token: token,
		labelsByCountry: labelsByCountry,
		isEcuador: isEcuador,
		isPeru: isPeru
	},
	methods: {
		getImageUrl: getImageUrl,
		goTo: goTo,
		loadData: loadData,
		onSearch: onSearch,
		replaceString: replaceString,
		setLocalData: setLocalData,
		showGenericError: showGenericError,
		showNotification: showNotification,
		showRow: showRow,
		stopClick: stopClick
	}
};

/* harmony default export */ __webpack_exports__["a"] = (mixin);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);


function round(value) {
	var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

	var newValue = Number(value);
	return newValue.toFixed(decimals);
}

function limitTo(value) {
	var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

	var cutText = value.substring(0, length);
	return cutText + '...';
}

function formatDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

	var newDate = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(new Date(date), formatter);
	return newDate;
}

function exactDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';
	var splitBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'T';

	if (date) {
		var dateSplit = date.split(splitBy);
		var dateComplete = dateSplit[0].split('-');
		var year = dateComplete[0];
		var month = dateComplete[1] - 1;
		var day = dateComplete[2];
		var newDate = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(new Date(year, month, day), formatter);
		return newDate;
	}
	return '';
}

function formatAmount(value) {
	return parseFloat(value).toLocaleString('en-US', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
}

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	Vue.filter('round', round);
	Vue.filter('limitTo', limitTo);
	Vue.filter('exactDate', exactDate);
	Vue.filter('formatDate', formatDate);
	Vue.filter('formatAmount', formatAmount);
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_layout_login__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_layout_admin__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_general_filter__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_table_app_table__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_header_page__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_form_sidebar__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_utils_modal_sidebar_button__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_apexcharts__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_app_button_list__ = __webpack_require__(717);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('layout-login', __WEBPACK_IMPORTED_MODULE_1__layouts_layout_login__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('layout-admin', __WEBPACK_IMPORTED_MODULE_2__layouts_layout_admin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-table', __WEBPACK_IMPORTED_MODULE_4__components_shared_table_app_table__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('header-page', __WEBPACK_IMPORTED_MODULE_5__components_shared_header_page__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('general-filter', __WEBPACK_IMPORTED_MODULE_3__components_shared_general_filter__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('form-sidebar', __WEBPACK_IMPORTED_MODULE_6__components_shared_form_sidebar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal-sidebar-button', __WEBPACK_IMPORTED_MODULE_7__components_shared_utils_modal_sidebar_button__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('apexchart', __WEBPACK_IMPORTED_MODULE_8_vue_apexcharts___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-button-list', __WEBPACK_IMPORTED_MODULE_9__components_shared_app_button_list__["a" /* default */]);

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_login_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2496fe80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_login_vue__ = __webpack_require__(702);
function injectStyle (ssrContext) {
  __webpack_require__(701)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2496fe80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2496fe80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_admin_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a7d7589_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_admin_vue__ = __webpack_require__(710);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a7d7589_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49a24056_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__(706);
function injectStyle (ssrContext) {
  __webpack_require__(705)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49a24056"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49a24056_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"media-print header-style header-responsive",attrs:{"app":"","height":"40"}},[_c('v-container',{attrs:{"fluid":"","py-0":""}},[_c('v-layout',{attrs:{"justify-space-between":"","align-center":""}},[_c('v-flex',{staticClass:"wrapper-btn-siderbar",attrs:{"xs1":""}},[_c('button',{staticClass:"btn-siderbar",on:{"click":function($event){return _vm.$emit('open-sidebar')}}},[(_vm.mini)?_c('img',{attrs:{"src":"/static/img/sidebar/menu.svg","alt":"menu-bars","width":"19px"}}):_c('img',{attrs:{"src":"/static/img/sidebar/close.svg","alt":"menu-bars","width":"19px","height":"13px"}})])]),_vm._v(" "),_c('v-flex',{attrs:{"text-xs-right":""}},[_c('div',{staticClass:"flex-item justify-end align-center"},[_c('button',{staticClass:"add-btn-container mr-2",on:{"click":_vm.goToNewCompany}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1),_vm._v(" "),_c('HeaderSelect',{staticClass:"select",attrs:{"return-object":"","placeholder":"Seleccione una Empresa","item-text":"name","item-value":"id","disabled":_vm.$route.meta.noChangeCompany,"height":23,"items":_vm.getGlobalSubsidiaries,"value":_vm.currentSubsidiary.id},on:{"input":_vm.$setCurrentSubsidiary}}),_vm._v(" "),_c('v-menu',[_c('button',{attrs:{"slot":"activator","type":"button"},slot:"activator"},[_c('div',{staticClass:"add-btn-wrapper"},[_c('div',{staticClass:"add-btn-icon"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("arrow_drop_down")])],1),_vm._v(" "),_c('p',{staticClass:"add-btn-text"},[_vm._v("Acciones")])])]),_vm._v(" "),_c('v-list',_vm._l((_vm.shortcuts),function(item,index){return _c('router-link',{key:index,staticClass:"company-modules-route",attrs:{"disabled":_vm.noSubsidiarySelected,"to":_vm.getRoute(item)}},[_c('v-list-tile',[_c('app-tooltip-button',{staticClass:"no-movil",attrs:{"img":item.icon,"text":item.title}}),_vm._v("\n\n\t\t\t\t\t\t\t\t\t"+_vm._s(item.title)+"\n\t\t\t\t\t\t\t\t")],1)],1)}),1)],1),_vm._v(" "),_c('div',{staticClass:"separate"}),_vm._v(" "),_c('div',{staticClass:"profile-image-container"},[_c('button',{staticClass:"d-flex",attrs:{"tabindex":"-1"},on:{"click":function($event){_vm.showMenu = !_vm.showMenu}}},[_c('img',{staticClass:"mr-2",attrs:{"src":_vm.userAvatar,"alt":"Imagen de Perfil de Usuario","height":"20","width":"20"}}),_vm._v(" "),_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.userName || 'Nombre del Usuario'))])]),_vm._v(" "),(_vm.showMenu)?_c('div',{staticClass:"content-menu"},[_c('div',{staticClass:"text-xs-center"},[_c('button',{on:{"click":_vm.openModal}},[_vm._v("Actualizar datos")])]),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_vm._v("Cerrar sesión")])])]):_vm._e()])],1)])],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"400"},model:{value:(_vm.activateModal),callback:function ($$v) {_vm.activateModal=$$v},expression:"activateModal"}},[_c('v-card',[_c('v-card-title',{staticClass:"title-data"},[_c('h5',{staticClass:"text-uppercase",attrs:{"caption":""}},[_vm._v("Actualizar datos")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"mx-4":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h5',{staticClass:"text-uppercase"},[_c('u',[_vm._v("Datos del contador")])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mx-4":"","my-4":""}},[_c('v-flex',{attrs:{"xs12":"","md6":"","px-3":""}},[_c('base-input',{attrs:{"label":"Nombre de usuario"},model:{value:(_vm.model.userName),callback:function ($$v) {_vm.$set(_vm.model, "userName", $$v)},expression:"model.userName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","px-3":""}},[_c('base-input',{attrs:{"label":"Teléfono"},model:{value:(_vm.model.phone),callback:function ($$v) {_vm.$set(_vm.model, "phone", $$v)},expression:"model.phone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","px-3":""}},[_c('base-input',{attrs:{"label":"Número de Cédula"},model:{value:(_vm.model.numberDocument),callback:function ($$v) {_vm.$set(_vm.model, "numberDocument", $$v)},expression:"model.numberDocument"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{attrs:{"mx-4":"","justify-end":""}},[_c('v-flex',{attrs:{"xs6":"","md4":""}},[_c('v-btn',{style:("color: #fff !important"),attrs:{"color":"#ff002b","small":""},on:{"click":_vm.closeModal}},[_vm._v("\n\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md4":""}},[_c('v-btn',{style:("color: #fff !important"),attrs:{"color":"teal darken-1","small":""},on:{"click":_vm.updateData}},[_vm._v("\n\t\t\t\t\t\t\t\tActualizar\n\t\t\t\t\t\t\t")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_sidebar_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a9127f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_sidebar_vue__ = __webpack_require__(709);
function injectStyle (ssrContext) {
  __webpack_require__(708)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a9127f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a9127f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticClass:"sidebar-border media-print",attrs:{"app":"","fixed":"","height":"100vh","hide-overlay":"","mini-variant-width":"53","mini-variant":_vm.mini,"stateless":"","width":"200"},on:{"update:miniVariant":function($event){_vm.mini=$event},"update:mini-variant":function($event){_vm.mini=$event}},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-toolbar',{staticClass:"background-bar hide-and-print",attrs:{"flat":"","height":"40"}},[_c('v-list',{staticClass:"pt-0"},[_c('v-list-tile',{staticClass:"align-image"},[(_vm.mini)?_c('v-list-tile-action',[_c('router-link',{attrs:{"to":{ name: _vm.nameRoute }}},[_c('img',{staticClass:"icon-maki-ocult",attrs:{"src":_vm.iconClose,"alt":"","width":"25","height":"29"}})])],1):_c('v-list-tile-action',[_c('router-link',{attrs:{"to":{ name: _vm.nameRoute }}},[_c('img',{staticClass:"imgLogo",attrs:{"src":_vm.iconOpen,"width":_vm.widthIcon,"height":"29"}})])],1)],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"btnMenu",attrs:{"flat":"","height":"60"}},[_c('v-list',[_c('v-list-tile',{staticClass:"bars-align",attrs:{"avatar":"","height":"60"}},[_c('v-list-tile-action',{staticClass:"btn-toggle",attrs:{"height":"60"}},[_c('v-btn',{staticClass:"icon-open-menu",attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.$emit('click-btn-toggle')}}},[(_vm.mini)?_c('img',{staticClass:"img-logo",attrs:{"src":"https://japi-static.s3.amazonaws.com/undefined/icon-menu-logo.png","width":"24","height":"24"}}):_c('img',{attrs:{"src":"/static/icon/close.svg","height":"18"}})])],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{staticClass:"sidebar-bg py-0"},_vm._l((_vm.items),function(item){return _c('v-list-group',{key:item.id,attrs:{"no-action":""}},[(item.resource.data.length === 0)?_c('v-list-tile',{attrs:{"slot":"activator","to":item.uri,"color":"white","active-class":"white--text"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.$emit('click-list')}},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"right":""}},[_c('img',{staticClass:"icon-sidebar",attrs:{"slot":"activator","src":item.pathIcon},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])])],1)],1):_c('v-list-tile',{staticClass:"padding-items",attrs:{"slot":"activator","color":"white"},slot:"activator"},[_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"right":""}},[_c('img',{staticClass:"icon-sidebar",attrs:{"slot":"activator","src":item.pathIcon},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"content-open ml-2 body-2 white--text"},[_c('v-list-tile-title',{staticClass:"itemName"},[_vm._v(_vm._s(item.name)+" ")]),_vm._v(" "),_c('img',{attrs:{"src":"https://japi-static.s3.amazonaws.com/undefined/triangle-sidebar.png","alt":"","width":"10","height":"10"}})],1)],1),_vm._v(" "),_vm._l((item.resource.data),function(subItem){return _c('v-list-tile',{key:subItem.uri,staticClass:"resources-items",attrs:{"to":{ name: subItem.uri },"color":"white","active-class":"white--text"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.$emit('click-list')}}},[_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"right":""}},[_c('v-icon',{staticClass:"title-action",attrs:{"slot":"activator","color":"white"},slot:"activator"},[_vm._v("lens")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(subItem.name))])],1)],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(subItem.name))])],1)],1)})],2)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[(_vm.showIndeterminate)?_c('v-progress-linear',{staticClass:"progress-bar",attrs:{"indeterminate":_vm.showIndeterminate}}):_vm._e(),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","pa-0":""}},[_c('app-header',{attrs:{"quantity-notifications":_vm.quantityNotifications,"mini":_vm.mini},on:{"open-notifications-event":_vm.openNotificationsModal,"open-sidebar":_vm.openSiderbar}}),_vm._v(" "),_c('app-sidebar',{attrs:{"is-visible":_vm.isVisible,"mini":_vm.mini},on:{"active-route":_vm.getRoutes,"click-list":_vm.clickListItem,"click-btn-toggle":_vm.openSiderbar}}),_vm._v(" "),_c('section',{staticClass:"section-margin"},[_vm._t("default")],2),_vm._v(" "),_c('action-sidebar',{attrs:{"width":_vm.action.width,"code-action":_vm.action.code,"title":_vm.action.title,"active":_vm.action.active,"img-src":_vm.action.imgSrc,"is-loading":_vm.loading,"header-color":_vm.action.color},model:{value:(_vm.action.open),callback:function ($$v) {_vm.$set(_vm.action, "open", $$v)},expression:"action.open"}}),_vm._v(" "),(!_vm.mini)?_c('div',{staticClass:"overlay-menu",on:{"click":_vm.clickListItem}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_sidebar_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_505ab6c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_sidebar_vue__ = __webpack_require__(713);
function injectStyle (ssrContext) {
  __webpack_require__(712)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-505ab6c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_505ab6c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-sidebar"},[_c('v-container',{staticClass:"grid-list-lg"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_sidebar_button_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d93c136e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_sidebar_button_vue__ = __webpack_require__(716);
function injectStyle (ssrContext) {
  __webpack_require__(715)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d93c136e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_sidebar_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d93c136e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_sidebar_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"footer-modal"},[_c('div',{staticClass:"footer-container"},[(!_vm.hidden)?_c('app-button',{attrs:{"text":"Cancelar","width":"109","red":""},on:{"click":_vm.cancelModal}}):_vm._e(),_vm._v(" "),(!_vm.hiddenSaveBtn)?_c('app-button',{attrs:{"text":_vm.successText,"disabled":_vm.isLoading,"width":"109","gray":""},on:{"click":_vm.setInfo}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_button_list_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07ee37a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_button_list_vue__ = __webpack_require__(719);
function injectStyle (ssrContext) {
  __webpack_require__(718)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07ee37a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_button_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07ee37a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_button_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex tw-justify-center tw-items-center"},[_vm._t("default"),_vm._v(" "),(_vm.showReportMenu)?_c('v-menu',{attrs:{"content-class":"report-menu-content","offset-y":"","nudge-bottom":5,"nudge-left":40,"open-on-click":_vm.openOnClick}},[_c('v-btn',{staticClass:"btn-auto-list py-1 px-1 mr-3",attrs:{"slot":"activator","flat":"","icon":""},on:{"click":function($event){return _vm.$emit('click-menu')}},slot:"activator"},[_c('img',{attrs:{"src":_vm.img,"alt":"download","height":"30"}})]),_vm._v(" "),_c('v-list',_vm._l((_vm.options),function(option){return _c('v-list-tile',{key:option.id,attrs:{"disabled":_vm.disabledOption && option.id === 2},on:{"click":function($event){return _vm.downloadDocument(option)}}},[_c('v-list-tile-title',[_vm._v("\n\t\t\t\t\t"+_vm._s(option.name)+"\n\t\t\t\t")])],1)}),1)],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]),[262]);


// WEBPACK FOOTER //
// static/js/app.4e76e7a0980bb0a53711.js